
      import Template7 from 'template7';
      const Template7Helpers = Template7.helpers;
  
      
  
      //import css for availability and price pages
var ReservationInformation;
var date = new Date();
var DateFrom;
var DateTo;
var RoomCategory;
var TommorowDay = date.setDate(date.getDate() + 1);
import '../css/new-reservation-complete.css';
import $$ from 'Dom7';
import actions from '../js/actions.js';
import URLS from '../js/Urls.js';

var moment = require('moment');

var TransferCalCheckOpen;
let transferTypeSheet;
let transferCategorySheet;
let transferSheet;
export default {
  data: function () {
    return {
      ReservationInfo: {},
      ReservationDetails: {},
      ReservationInformation: {},
      Name: {},
      loginobject: {},
      AllRoomsList: {},
      RoomsList: {},
      Countries: {},
      RateList: {},
      RoomCatsList: {},
      Billings: {},
      TransfersType: {},
      TransfersCategory: {},
      Companies: {},
      Agencies: {},
      Tourismins: {},
      MaxAdults: 0,
      MaxChildren: 0,
      emailID: 0,
      PropertyID: 0,
      UserID: 0,
      isHouseKeeper: false
    };
  },
  beforeDestroy: async function () {},
  methods: {
    openConversation: function (uID, reservationID) {
      try {
        const obj = {
          uID: uID,
          reservationID: reservationID
        };
        localStorage.setItem("converastion", JSON.stringify(obj));
        app.f7.views.main.router.navigate(`/conversations/`, {
          transition: 'f7-dive'
        });
      } catch (err) {
        console.log(err);
      }
    },

    toggleMoreLess(ID) {
      var element = $('#mhml_' + ID);
      var messagewrap = $('#mh_' + ID);
      var parentElement = element.parent();

      if (parentElement.hasClass('read-less')) {
        parentElement.removeClass('read-less');
        parentElement.find('a').html('... More');
        messagewrap.addClass('limited-content');
      } else {
        parentElement.addClass('read-less');
        parentElement.find('a').html('... Show less');
        messagewrap.removeClass('limited-content');
      }
    },

    sendEmailConfrim: async function () {
      const self = this;
      app.f7.dialog.confirm('Are you sure?', "", async function () {
        const emailResponse = await self.SendMobileEmail();
        app.f7.dialog.alert(emailResponse, "");
      });
    },

    makeCall(GuestPhone) {
      if (GuestPhone) {
        let sanitizedPhone = GuestPhone.replace(/\s+/g, '');

        if (this.isIos()) {
          try {
            cordova.InAppBrowser.open('tel:' + sanitizedPhone, "_system", "location=yes");
          } catch {
            window.location.href = 'tel:' + sanitizedPhone;
          }
        } else {
          window.location.href = 'tel:' + sanitizedPhone;
        }
      } else {
        console.log("Phone number is not available");
      }
    },

    isIos() {
      return ['iPad Simulator', 'iPhone Simulator', 'iPod Simulator', 'iPad', 'iPhone', 'iPod'].includes(navigator.platform) // iPad on iOS 13 detection
      || navigator.userAgent.includes("Mac") && "ontouchend" in document;
    },

    sendSMS(GuestPhone) {
      if (GuestPhone) {
        let sanitizedPhone = GuestPhone.replace(/\s+/g, '');

        if (this.isIos()) {
          try {
            cordova.InAppBrowser.open('sms:' + sanitizedPhone, "_system", "location=yes");
          } catch {
            window.location.href = 'sms:' + sanitizedPhone;
          }
        } else {
          window.location.href = 'sms:' + sanitizedPhone;
        }
      } else {
        console.log("Phone number is not available");
      }
    },

    openWhatsApp(GuestPhone) {
      window.open('https://api.whatsapp.com/send?phone=' + GuestPhone, '_system');
    },

    copyToClipboard(GuestPhone) {
      var dummy = document.createElement("textarea");
      document.body.appendChild(dummy);
      dummy.value = GuestPhone;
      dummy.select();
      document.execCommand("copy");
      document.body.removeChild(dummy);
    },

    selectEmail() {
      var self = this;
      var selectedValue = parseInt(emailSelect.value);
      var checkEmailID = 0;
      var selectedTemplate = this.ReservationInformation?.EmailTemplates.find(template => template.ID === selectedValue);
      var tmpEmailResp = selectedTemplate?.Body?.replace("padding", "")?.replace(/width/g, "");
      $$("#emailBody").html(tmpEmailResp);
      $$("#emailSubject").val(selectedTemplate?.Subject);
      $$("#hEmailID").val(selectedTemplate?.ID);
    },

    SendMobileEmail: async function () {
      const self = this;
      const emailID = $$("#hEmailID").val();
      const emailSubject = $$("#emailSubject").val();
      const emailBody = $$("#emailBody").html();
      const emailTo = $$("#emailTo").val();
      const sanitizedEmailBody = this.escapeHtml(emailBody);
      const sanitizedEmailSubject = this.escapeHtml(emailSubject);
      var emailObj = {
        PropertyID: this.PropertyID,
        UserID: this.UserID,
        EmailID: emailID,
        ReservationID: this.ReservationInformation.ReservationID,
        CustomerID: this.ReservationInformation.CustomerID,
        Email: emailTo,
        EmailBody: sanitizedEmailBody,
        EmailSubject: sanitizedEmailSubject
      };
      app.f7.preloader.show();
      let response = await app.f7.request.promise.post(URLS.SendMobileEmail, {
        emailObj
      });
      app.f7.preloader.hide();
      const tmpEmailResp = JSON.parse(response.data);
      return tmpEmailResp;
    },
    escapeHtml: function (html) {
      var text = document.createElement('textarea');
      text.textContent = html;
      return text.innerHTML;
    },
    GetBillingTypes: async function () {
      var self = this;
      var ReservationID = localStorage.getItem('ReservationID');
      ReservationID = JSON.parse(ReservationID);
      app.f7.preloader.show();
      await app.f7.request.promise.post(URLS.GetPaymentTypes, {
        PropertyID: this.PropertyID
      }).then(res => {
        var billings = JSON.parse(res.data);
        this.$update(function () {
          self.$setState({
            Billings: billings
          }).then(res => {
            app.f7.smartSelect.get('.showsmartselectbillings').setValue(billings[0].Key);
            app.f7.sheet.open('.my-sheet', true);
          });
        });
        app.f7.preloader.hide();
      });
    },
    EditThisPayment: async function (ID, Amount, PaymentID) {
      var self = this;
      var ReservationID = localStorage.getItem('ReservationID');
      ReservationID = JSON.parse(ReservationID);
      app.f7.preloader.show();
      await app.f7.request.promise.post(URLS.GetPaymentTypes, {
        PropertyID: this.PropertyID
      }).then(res => {
        var billings = JSON.parse(res.data);
        this.$update(function () {
          self.$setState({
            Billings: billings
          }).then(res => {
            app.f7.sheet.open('.my-sheet', true);
            app.f7.smartSelect.get('.showsmartselectbillings').setValue(ID);
            $$("#AddPaymentID").val(Amount);
            $$("#hPaymentID").val(PaymentID);
          });
        });
        app.f7.preloader.hide();
      });
    },
    DeleteThisPayment: async function (PaymentID, Amount) {
      var self = this;
      var ReservationID = localStorage.getItem('ReservationID');
      ReservationID = JSON.parse(ReservationID);
      Amount = Amount.toString().replace(",", ".");
      var obj = {
        PropertyID: this.PropertyID,
        UserID: this.UserID,
        reservId: ReservationID,
        PaymentID: PaymentID,
        TotalPrice: Amount,
        ActionToDo: 3
      };
      app.f7.preloader.show();
      await app.f7.request.promise.postJSON(URLS.CreateEditDepositPayment, {
        obj
      }).then(res => {
        app.f7.preloader.hide();

        if (res.data === "Ok") {
          app.f7.views.main.router.navigate(app.f7.views.main.router.currentRoute.url, {
            reloadCurrent: true
          });
        } else {
          var message = res.data;

          if (res.data == "StartShift") {
            message = "Shift needs to be started";
          }

          var toastWithCustomButton = app.f7.toast.create({
            text: message,
            closeButton: true,
            closeButtonText: "Close Me",
            closeButtonColor: "red"
          });
        }
      });
    },
    SavePayment: async function (e) {
      var ReservationID = localStorage.getItem('ReservationID');
      ReservationID = JSON.parse(ReservationID);
      app.f7.sheet.close('.my-sheet', true);
      var PaymentType = app.f7.smartSelect.get('.showsmartselectbillings').getValue();
      var Amount = $$('#AddPaymentID').val();
      var actionToDo = 1;
      Amount = Amount.toString().replace(",", ".");
      var payCheck = $$("#hPaymentID").val();

      if (payCheck != null && payCheck != "" && payCheck != 0) {
        actionToDo = 2;
      }

      try {
        app.f7.preloader.show();
        var obj = {};

        if (actionToDo == 2) {
          obj = {
            PropertyID: this.PropertyID,
            UserID: this.UserID,
            reservId: ReservationID,
            PaymentTypeID: PaymentType,
            TotalPrice: Amount,
            ActionToDo: actionToDo,
            PaymentID: payCheck
          };
        } else {
          obj = {
            PropertyID: this.PropertyID,
            UserID: this.UserID,
            reservId: ReservationID,
            PaymentTypeID: PaymentType,
            TotalPrice: Amount,
            ActionToDo: actionToDo
          };
        }

        app.f7.smartSelect.close('.showsmartselectbillings');
        await app.f7.request.promise.postJSON(URLS.CreateEditDepositPayment, {
          obj
        }).then(res => {
          app.f7.preloader.hide();

          if (res.data === "Ok") {
            app.f7.views.main.router.navigate(app.f7.views.main.router.currentRoute.url, {
              reloadCurrent: true
            });
          } else {
            var toastWithCustomButton = app.f7.toast.create({
              text: res.data,
              closeButton: true,
              closeButtonText: "Close Me",
              closeButtonColor: "red"
            });
          }
        });
      } catch (ex) {
        app.f7.preloader.hide();
      }
    },
    CloseCancel: async function (e) {
      $$('#CancelResID').html("");
      $$('#CancelBookingDate').html("");
      $$('#CancelSource').html("");
      $$('#CancelCheckinOut').html("");
      $$('#CancelCustomer').html("");
      $$('#CancelReservationCharges').html("");
      $$('#CancelRateName').html("");
      $$('#CancelCancelationPolicy').html("");
      $$('#CancellationFeeText').val("");
      $$('#CancellationFee').val("");
      app.f7.sheet.close('.my-sheet-cancel', true);
    },
    CancelFeeForValidDecimal: async function () {
      var input = $$("#CancellationFee").val();

      if (input.indexOf(',') != -1) {
        input = input.replace(',', '.');
        $$("#CancellationFee").val(input);
      }
    },
    GetNotes: async function () {
      var self = this;
      app.f7.preloader.show();
      await app.f7.request.promise.post(URLS.GetNotes, {}).then(res => {
        var billings = JSON.parse(res.data);
        this.$update(function () {
          self.$setState({
            Billings: billings
          }).then(res => {
            app.f7.smartSelect.get('.showsmartselectnotes').setValue(billings[0].Key);
            app.f7.sheet.open('.my-sheet-notes', true);
          });
        });
        app.f7.preloader.hide();
      });
    },
    SaveNote: async function (e) {
      var ReservationID = localStorage.getItem('ReservationID');
      ReservationID = JSON.parse(ReservationID);
      app.f7.sheet.close('.my-sheet-notes', true);
      var noteType = app.f7.smartSelect.get('.showsmartselectnotes').getValue();
      var noteText = $$('#AddNoteID').val();
      var actionToDo = 1;
      var noteCheck = $$("#hNoteID").val();

      if (noteCheck != null && noteCheck != "" && noteCheck != 0) {
        actionToDo = 2;
      }

      try {
        app.f7.preloader.show();
        var obj = {};

        if (actionToDo == 2) {
          obj = {
            PropertyID: this.PropertyID,
            UserID: this.UserID,
            reservId: ReservationID,
            NoteTypeID: noteType,
            NoteText: noteText,
            NoteID: noteCheck
          };
        } else {
          obj = {
            PropertyID: this.PropertyID,
            UserID: this.UserID,
            reservId: ReservationID,
            NoteTypeID: noteType,
            NoteText: noteText
          };
        }

        app.f7.smartSelect.close('.showsmartselectnotes');
        await app.f7.request.promise.postJSON(URLS.SaveNote, {
          obj
        }).then(res => {
          app.f7.preloader.hide();

          if (res.data === "Ok") {
            app.f7.views.main.router.navigate(app.f7.views.main.router.currentRoute.url, {
              reloadCurrent: true
            });
          }
        });
      } catch (ex) {
        app.f7.preloader.hide();
      }
    },
    EditThisNote: async function (ID, NoteText, NoteID) {
      var self = this;
      var ReservationID = localStorage.getItem('ReservationID');
      ReservationID = JSON.parse(ReservationID);
      app.f7.preloader.show();
      await app.f7.request.promise.post(URLS.GetNotes, {
        PropertyID: this.PropertyID
      }).then(res => {
        var billings = JSON.parse(res.data);
        this.$update(function () {
          self.$setState({
            Billings: billings
          }).then(res => {
            app.f7.sheet.open('.my-sheet-notes', true);
            app.f7.smartSelect.get('.showsmartselectnotes').setValue(ID);
            $$("#AddNoteID").val(NoteText);
            $$("#hNoteID").val(NoteID);
          });
        });
        app.f7.preloader.hide();
      });
    },
    DeleteThisNote: async function (NoteID, NoteText) {
      var self = this;
      var ReservationID = localStorage.getItem('ReservationID');
      ReservationID = JSON.parse(ReservationID);
      var obj = {
        PropertyID: this.PropertyID,
        UserID: this.UserID,
        reservId: ReservationID,
        NoteID: NoteID,
        NotesText: NoteText
      };
      app.f7.preloader.show();
      await app.f7.request.promise.postJSON(URLS.DeleteNote, {
        obj
      }).then(res => {
        app.f7.preloader.hide();

        if (res.data === "Ok") {
          app.f7.views.main.router.navigate(app.f7.views.main.router.currentRoute.url, {
            reloadCurrent: true
          });
        }
      });
    },
    GetTransfers: async function () {
      var self = this;
      app.f7.preloader.show();
      await app.f7.request.promise.post(URLS.GetTransfers, {}).then(res => {
        var transfers = JSON.parse(res.data);
        var editCheck = $$("#hTransfersID").val();
        $$("#DeleteTransfersID").hide();
        this.$update(function () {
          self.$setState({
            TransfersType: transfers.transferTypeList,
            TransfersCategory: transfers.categoryList
          }).then(res => {
            app.f7.smartSelect.get('.showsmartselecttransfers').setValue(transfers.transferTypeList[0].keyVal.Key);
            app.f7.smartSelect.get('.showsmartselecttransferscatefory').setValue(transfers.categoryList[0].keyVal.Key);
            app.f7.sheet.open('.my-sheet-transfers', true);
            transferSheet = app.f7.sheet.get('.my-sheet-transfers');
            transferTypeSheet = app.f7.sheet.get('.showsmartselecttransfers');
            transferCategorySheet = app.f7.sheet.get('.showsmartselecttransferscatefory');
            TransferCalCheckOpen = false;
          });
        });
        app.f7.preloader.hide();
      });
    },
    SaveTransfers: async function (e) {
      var ReservationID = localStorage.getItem('ReservationID');
      ReservationID = JSON.parse(ReservationID);
      app.f7.sheet.close('.my-sheet-transfers', true);
      var transferType = app.f7.smartSelect.get('.showsmartselecttransfers').getValue();
      var transferDate = $$('#AddTransferDate').val();
      var transferPickup = $$('#AddTransferPickup').val();
      var transferDeliver = $$('#AddTransferDeliver').val();
      var transferDriver = $$('#AddTransferDriver').val();
      var transferCategory = app.f7.smartSelect.get('.showsmartselecttransferscatefory').getValue();
      var transferFlightNumber = $$('#AddTransferFlightNumber').val();
      var transferPeople = $$('#AddTransferPeople').val();
      var transferPrice = $$('#AddTransferPrice').val();
      var actionToDo = 1;
      var transferCheck = $$("#hTransfersID").val();

      if (transferCheck != null && transferCheck != "" && transferCheck != 0) {
        actionToDo = 2;
      }

      try {
        app.f7.preloader.show();
        var obj = {};

        if (actionToDo == 2) {
          obj = {
            PropertyID: this.PropertyID,
            UserID: this.UserID,
            reservId: ReservationID,
            TransferType: transferType,
            TransferDate: transferDate,
            TransferPickup: transferPickup,
            TransferDeliver: transferDeliver,
            TransferDriver: transferDriver,
            TransferCategory: transferCategory,
            TransferFlightNumber: transferFlightNumber,
            TransferPeople: transferPeople,
            TransferPrice: transferPrice,
            TransferID: transferCheck
          };
        } else {
          obj = {
            PropertyID: this.PropertyID,
            UserID: this.UserID,
            reservId: ReservationID,
            TransferType: transferType,
            TransferDate: transferDate,
            TransferPickup: transferPickup,
            TransferDeliver: transferDeliver,
            TransferDriver: transferDriver,
            TransferCategory: transferCategory,
            TransferFlightNumber: transferFlightNumber,
            TransferPeople: transferPeople,
            TransferPrice: transferPrice
          };
        }

        app.f7.smartSelect.close('.showsmartselecttransfers');
        app.f7.smartSelect.close('.showsmartselecttransferscatefory');
        await app.f7.request.promise.postJSON(URLS.SaveTransfers, {
          obj
        }).then(res => {
          app.f7.preloader.hide();

          if (res.data === "Ok") {
            app.f7.views.main.router.navigate(app.f7.views.main.router.currentRoute.url, {
              reloadCurrent: true
            });
            TransferCalCheckOpen = false;
          }
        });
      } catch (ex) {
        app.f7.preloader.hide();
      }
    },
    EditThisTransfers: async function (ID, TransferType, TransferDateStr, PickupLocation, DeliverLocation, Driver, TransferCategory, FlightNumber, People, TotalPrice) {
      var self = this;
      var ReservationID = localStorage.getItem('ReservationID');
      ReservationID = JSON.parse(ReservationID);
      $$("#DeleteTransfersID").show();
      app.f7.preloader.show();
      await app.f7.request.promise.post(URLS.GetTransfers, {}).then(res => {
        var transfers = JSON.parse(res.data);
        this.$update(function () {
          self.$setState({
            TransfersType: transfers.transferTypeList,
            TransfersCategory: transfers.categoryList
          }).then(res => {
            app.f7.sheet.open('.my-sheet-transfers', true);
            app.f7.smartSelect.get('.showsmartselecttransfers').setValue(TransferType);
            app.f7.smartSelect.get('.showsmartselecttransferscatefory').setValue(TransferCategory);
            $$("#AddTransferDate").val(TransferDateStr);
            $$("#AddTransferPickup").val(PickupLocation);
            $$("#AddTransferDeliver").val(DeliverLocation);
            $$("#AddTransferDriver").val(Driver);
            $$("#AddTransferFlightNumber").val(FlightNumber);
            $$("#AddTransferPeople").val(People);
            $$("#AddTransferPrice").val(TotalPrice);
            $$("#hTransfersID").val(ID);
            TransferCalCheckOpen = false;
          });
        });
        app.f7.preloader.hide();
      });
    },
    DeleteThisTransfers: async function (NoteID, NoteText) {
      var self = this;
      var ReservationID = localStorage.getItem('ReservationID');
      ReservationID = JSON.parse(ReservationID);
      var transferCheck = $$("#hTransfersID").val();
      var obj = {
        PropertyID: this.PropertyID,
        UserID: this.UserID,
        reservId: ReservationID,
        TransferID: transferCheck
      };
      app.f7.preloader.show();
      await app.f7.request.promise.postJSON(URLS.DeleteTransfers, {
        obj
      }).then(res => {
        app.f7.preloader.hide();

        if (res.data === "Ok") {
          app.f7.views.main.router.navigate(app.f7.views.main.router.currentRoute.url, {
            reloadCurrent: true
          });
          app.f7.smartSelect.close('.showsmartselecttransfers');
          app.f7.smartSelect.close('.showsmartselecttransferscatefory');
          app.f7.sheet.close('.my-sheet-transfers', true);
        }
      });
    },

    updateHeroOpenOne3() {
      $('#selectedroom').css("display", "none");
    },

    updateHeroOpenOne: async function () {
      var self = this;
      var customerReservation = localStorage.getItem('ReservationInfo');
      var ReservationID = localStorage.getItem('ReservationID'); // pairnw thn opliroforia tou local storage

      ReservationID = JSON.parse(ReservationID);
      var roomCategory = app.f7.smartSelect.get('.smartselectroomcategory1').getValue();
      var change = false;
      var tmpRoomCategory = $$("#hRoomCategoryID").val();

      if (roomCategory != null && roomCategory != "" && roomCategory != "0" && roomCategory != tmpRoomCategory) {
        change = true;
      }

      const UserSpecificApiKey = this.loginobject?.PropertiesList?.find(property => property.PropertyName == this.loginobject?.PropertyName)?.UserSpecificApiKey;
      var object = {
        ReservationID: ReservationID,
        PropertyID: this.PropertyID,
        RoomCategory: roomCategory,
        DateTo: DateTo,
        DateFrom: DateFrom,
        UserSpecificApiKey: UserSpecificApiKey
      };

      try {
        if (change) {
          app.f7.preloader.show();
          let response = await app.f7.request.promise.post(URLS.GetAvailRoomsForEdit, {
            object
          }).then(res => {
            var roomslist = JSON.parse(res.data);
            this.$update(function () {
              self.$setState({
                RoomsList: roomslist,
                RateList: roomslist,
                RoomCatsList: roomslist.RoomCatsList
              }).then(res => {
                var roomListLength = 0;
                roomListLength = roomslist.RoomsList.length;

                if (roomListLength > 1) {
                  app.f7.smartSelect.get('.smartselectroom').setValue(roomslist.RoomsList[1].Key);
                } else {
                  app.f7.smartSelect.get('.smartselectroom').setValue(roomslist.RoomsList[0].Key);
                }

                app.f7.smartSelect.get('.smartselectroomrate').setValue(roomslist.RatesList[0].Key);
              });
            });
            app.f7.preloader.hide();
          });
        }
      } catch (error) {
        console.log(error);
      }
    }
  },
  on: {
    pageBeforeIn: function (e, page) {},
    pageInit: async function (e, page) {
      const {
        id
      } = page.route.params;
      var self = this;
      var $ = self.$;
      const loginobject = actions.LoginGetResult();
      self.$setState({
        UserID: loginobject.UserID,
        PropertyID: loginobject.PropertyID,
        loginobject: loginobject,
        isHouseKeeper: loginobject?.IsHousekeeper
      });
      var ReservationID = localStorage.getItem('ReservationID');
      ReservationID = JSON.parse(ReservationID);

      function isCallSupported() {
        // Check if the device supports making calls
        // Example: return true if the device is a mobile phone
        $$('*[data-action="isCallSupported"]').hide();
        return;
      }

      ;

      function isSMSSupported() {
        // Check if the device supports sending SMS
        // Example: return true if the device is a mobile phone
        $$('*[data-action="isCallSupported"]').hide();
        return;
      }

      /* Logic to determine if sending SMS is supported */
      ; // function isWhatsAppSupported() {
      //   // Check if WhatsApp is installed on the device
      //   // Example: Use Cordova plugin to check if WhatsApp is installed
      //   $$('*[data-action="isCallSupported"]').hide();
      //   return /* Logic to determine if WhatsApp is supported */;
      // };
      //an erthei id apo to onesignal tote na anoiksei ayto to reservation

      if (id) {
        ReservationID = id;
      }

      var AllROOms;
      var ReservationInfo;
      var obj = {
        PropertyID: self.PropertyID,
        UserID: self.UserID,
        ReservationID: ReservationID
      };

      try {
        app.f7.preloader.show();
        var currency = await actions.GetUserCurrency();
        await app.f7.request.promise.postJSON(URLS.GetReservationDetails, {
          obj
        }).then(res => {
          AllROOms = res.data.AllRoomCategories;
          ReservationInfo = res.data?.CustomerReservations[0]; //this.$update();

          self.$tick(() => {// DOM updated
          });
          ReservationInfo.Currency = currency;

          for (var i in ReservationInfo.AppPayments) {
            ReservationInfo.AppPayments[i].Currency = currency;
          }

          app.f7.preloader.hide();
        });
      } catch (e) {}

      var allcountries = localStorage.getItem('Countries');
      allcountries = JSON.parse(allcountries);
      self.$setState({
        Countries: allcountries
      });
      var customerReservation = ReservationInfo;
      var roomsList = AllROOms;
      var CustomId = customerReservation?.CustomerID;
      var reservId = customerReservation?.ReservationID;
      var CustomerEmail = customerReservation?.GuestEmail1;
      var starterFirstName = customerReservation?.CustomerFirstName.charAt(0).toUpperCase();
      var starterLastName = customerReservation?.CustomerLastName.charAt(0).toUpperCase();
      var sanitizedGuestInfo1Surname = customerReservation?.GuestSurname1.trim().replace(/\s+/g, '');
      self.$setState({
        ReservationInformation: { ...customerReservation,
          GuestSurname1: sanitizedGuestInfo1Surname
        },
        CustomerInitialsFirstName: starterFirstName,
        CustomerInitialsLastName: starterLastName,
        AllRoomsList: customerReservation?.RoomsList,
        RateList: customerReservation,
        RoomsList: customerReservation,
        RoomCatsList: customerReservation?.RoomCatsList,
        Name: "test"
      }).then(() => {
        if (!self.isHouseKeeper) {
          app.f7.smartSelect.get('.smartselectroomcategory1').setValue(customerReservation?.RoomCategoryID);
          app.f7.smartSelect.get('.smartselectroom').setValue(customerReservation?.RoomID);
          app.f7.smartSelect.get('.smartselectroomrate').setValue(customerReservation?.RateID);
          app.f7.stepper.get('.quest_stepper').setValue(customerReservation?.Adults);
          app.f7.stepper.get('.children_stepper').setValue(customerReservation?.Children);
          app.f7.smartSelect.get('.showsmartselectemail').setValue(0);
        }

        app.f7.smartSelect.get('#smartselectorigin').setValue(customerReservation?.OriginID);
        app.f7.smartSelect.get('#smartselectsource').setValue(customerReservation?.SourceID);
        app.f7.smartSelect.get('#smartselectbusinesssegment').setValue(customerReservation?.BusinessSegmentID);
        app.f7.smartSelect.get('.smartselectCountryG1').setValue(customerReservation?.GuestCountry1);
        app.f7.smartSelect.get('.smartselectCountryG2').setValue(customerReservation?.GuestCountry2); //Cancelation policy

        app.f7.smartSelect.get('.showsmartselect').setValue(customerReservation?.CancellationPolicyID); //PaymentPolicy

        app.f7.smartSelect.get('.showsmartselect2').setValue(customerReservation?.PaymentPolicyID);
        $$("#hRoomCategoryID").val(customerReservation?.RoomCategoryID);
        $$("#hRoomID").val(customerReservation?.RoomID);
        $$("#hRateID").val(customerReservation?.RateID);
      });
      GetCompanyTravelToursimList(); // $$("#emailSelect").on('change', async () => {
      //   var selectedValue = parseInt(emailSelect.value);
      //   var checkEmailID = 0;
      //   app.f7.smartSelect.get('.showsmartselectemail').close();
      //   var selectedTemplate = customerReservation?.EmailTemplates.find(template => template.ID === selectedValue);
      //   var tmpEmailResp = selectedTemplate?.Body?.replace("padding", "")?.replace(/width/g, "");
      //   $$("#emailBody").html(tmpEmailResp);
      //   $$("#emailSubject").val(selectedTemplate?.Subject);
      //   $$("#hEmailID").html(selectedTemplate?.ID);
      // });

      $('.NotesEditbtn').on('click', async e => {
        var $element = $$(e.target);
        var regfresh = $(e.target).attr('data-refresh'); //Get Attribute

        if (regfresh == 1) {
          try {
            var obj = {
              PropertyID: self.PropertyID,
              UserID: self.UserID,
              ReservationID: reservId
            };
            app.f7.views.main.router.navigate(app.f7.views.main.router.currentRoute.url, {
              reloadCurrent: true,
              ignoreCache: true
            });
          } catch (error) {
            console.log(error);
          }
        } else {
          var $textarea = $element.parent().parent().find('.noteReservation');
          $textarea.removeClass("disabled", false);
          $textarea.focus();
          var $savebtn = $($element).prev();
          $savebtn.show();
          $element.attr("data-refresh", 1);
          $element.text("Cancel");
          const UserSpecificApiKey = loginobject?.PropertiesList?.find(property => property.PropertyName == loginobject?.PropertyName)?.UserSpecificApiKey;
          var object = {
            ReservationID: reservId,
            PropertyID: self.PropertyID,
            RoomCategory: RoomCategory,
            DateTo: DateTo,
            DateFrom: DateFrom,
            UserSpecificApiKey: UserSpecificApiKey
          };

          try {
            app.f7.preloader.show();
            let response = await app.f7.request.promise.post(URLS.GetAvailRoomsForEdit, {
              object
            }).then(res => {
              var roomslist = JSON.parse(res.data);
              var ratelist = roomslist;
              app.f7.preloader.hide();
              self.$setState({
                RoomsList: roomslist,
                RateList: ratelist,
                RoomCatsList: roomslist.RoomCatsList
              });
            });
          } catch {}
        }
      });
      $('.NotesSavebtn').on('click', async function () {
        var List = [];
        $$('.noteReservation').each(function (k, v) {
          var value = $$(this).val();
          var id = $$(this).attr("name");
          value = $$(this).val();
          var tmpobj = {
            NoteID: id,
            Notes: value
          };
          List.push(tmpobj);
        });
        var obj = {
          PropertyID: self.PropertyID,
          UserID: self.UserID,
          CustomId: CustomId,
          reservId: reservId,
          ReservationID: reservId,
          NotesList: List
        };

        try {
          app.f7.preloader.show();
          let response = await app.f7.request.promise.postJSON(URLS.EditReservationNotes, {
            obj
          });
          app.f7.preloader.hide();

          if (response.data === "Ok") {
            app.f7.views.main.router.navigate(app.f7.views.main.router.currentRoute.url, {
              reloadCurrent: true
            });
          } else {
            var toastWithCustomButton = app.f7.toast.create({
              text: 'Error',
              closeButton: true,
              closeButtonText: 'Close Me',
              closeButtonColor: 'red',
              closeTimeout: 3000
            });
            toastWithCustomButton.open();
          }
        } catch (error) {
          app.f7.preloader.hide();
          console.log(error);
        }
      });
      $('.SegmentationEditBtn').on('click', async e => {
        var $element = $$(e.target);
        var regfresh = $(e.target).attr('data-refresh');

        if (regfresh == 1) {
          $$('.segmentationCard .tmp-disabled').each(function () {
            $$(this).removeClass("tmp-disabled", false);
            $$(this).addClass("disabled", false);
          });
          var $savebtn = $($element).prev();
          $savebtn.hide();
          $element.attr("data-refresh", 0);
          $element.text("Edit");
        } else {
          $$('.segmentationCard .disabled').each(function () {
            $$(this).removeClass("disabled", false);
            $$(this).addClass("tmpv-disabled", false);
          });
          var $savebtn = $($element).prev();
          $savebtn.show();
          $element.attr("data-refresh", 1);
          $element.text("Cancel");
        }
      });
      $('.SegmentationSaveBtn').on('click', async function () {
        var selectedOrigin = app.f7.smartSelect.get('#smartselectorigin').getValue();
        var selectedSource = app.f7.smartSelect.get('#smartselectsource').getValue();
        var selectedBusinesssegment = app.f7.smartSelect.get('#smartselectbusinesssegment').getValue();
        var obj = {
          PropertyID: self.PropertyID,
          UserID: self.UserID,
          CustomId: CustomId,
          reservId: reservId,
          ReservationID: reservId,
          selectedOrigin: selectedOrigin,
          selectedSource: selectedSource,
          selectedTravelReason: selectedBusinesssegment
        };

        try {
          app.f7.preloader.show();
          let response = await app.f7.request.promise.postJSON(URLS.EditReservationSegmentation, {
            obj
          });
          app.f7.preloader.hide();

          if (response.data === "Ok") {
            app.f7.views.main.router.navigate(app.f7.views.main.router.currentRoute.url, {
              reloadCurrent: true
            });
          } else {
            var toastWithCustomButton = app.f7.toast.create({
              text: 'Error',
              closeButton: true,
              closeButtonText: 'Close Me',
              closeButtonColor: 'red',
              closeTimeout: 3000
            });
            toastWithCustomButton.open();
          }
        } catch (error) {
          app.f7.preloader.hide();
          console.log(error);
        }
      });
      $('.PolicyEditBtn').on('click', async e => {
        var $element = $$(e.target);
        var regfresh = $(e.target).attr('data-refresh');

        if (regfresh == 1) {
          $$('.policyCard .tmp-disabled').each(function () {
            $$(this).removeClass("tmp-disabled", false);
            $$(this).addClass("disabled", false);
          });
          var $savebtn = $($element).prev();
          $savebtn.hide();
          $element.attr("data-refresh", 0);
          $element.text("Edit");
        } else {
          $$('.policyCard .disabled').each(function () {
            $$(this).removeClass("disabled", false);
            $$(this).addClass("tmp-disabled", false);
          });
          var $savebtn = $($element).prev();
          $savebtn.show();
          $element.attr("data-refresh", 1);
          $element.text("Cancel");
        }
      });
      $('.PolicySaveBtn').on('click', async function () {
        var selectedCancellationPolicie = app.f7.smartSelect.get('.showsmartselect').getValue();
        var selectedPaymentPolicie = app.f7.smartSelect.get('.showsmartselect2').getValue();
        var obj = {
          PropertyID: self.PropertyID,
          UserID: self.UserID,
          CustomId: CustomId,
          reservId: reservId,
          ReservationID: reservId,
          selectedCancellationPolicie: selectedCancellationPolicie,
          selectedPaymentPolicie: selectedPaymentPolicie
        };

        try {
          app.f7.preloader.show();
          let response = await app.f7.request.promise.postJSON(URLS.EditReservationPolicies, {
            obj
          });
          app.f7.preloader.hide();

          if (response.data === "Ok") {
            app.f7.views.main.router.navigate(app.f7.views.main.router.currentRoute.url, {
              reloadCurrent: true
            });
          } else {
            var toastWithCustomButton = app.f7.toast.create({
              text: 'Error',
              closeButton: true,
              closeButtonText: 'Close Me',
              closeButtonColor: 'red',
              closeTimeout: 3000
            });
            toastWithCustomButton.open();
          }
        } catch (error) {
          app.f7.preloader.hide();
          console.log(error);
        }
      });
      DateFrom = customerReservation?.CheckInDateString;
      DateTo = customerReservation?.CheckOutDateString;
      RoomCategory = customerReservation?.RoomCategory;
      $$('.runIcon').on('click', function () {
        app.f7.views.main.router.navigate('/new-reservation-home/');
      });
      $$('#editbtnnewdatesin').on('click', async () => {
        var regfresh = $$('#editbtnnewdatesin').attr('data-refresh');

        if (regfresh == 1) {
          $$('.roomdetails .tmp-disabled').each(function () {
            $$(this).addClass("disabled", false);
            $$(this).removeClass("tmp-disabled", false);
          });
          $$('#ResDetailsbtnSave').hide();
          $$('#editbtnnewdatesin').attr("data-refresh", 0);
          $$('#editbtnnewdatesin').text("Edit");
        } else {
          $$('.roomdetails .disabled').each(function () {
            $$(this).removeClass("disabled", false);
            $$(this).addClass("tmp-disabled", false);
          });
          $$('#ResDetailsbtnSave').show();
          $$('#editbtnnewdatesin').attr("data-refresh", 1);
          $$('#editbtnnewdatesin').text("Cancel");
          const UserSpecificApiKey = loginobject?.PropertiesList?.find(property => property.PropertyName == loginobject?.PropertyName)?.UserSpecificApiKey;
          var object = {
            ReservationID: reservId,
            PropertyID: self.PropertyID,
            RoomCategory: RoomCategory,
            DateTo: DateTo,
            DateFrom: DateFrom,
            UserSpecificApiKey: UserSpecificApiKey
          };

          try {
            app.f7.preloader.show();
            let response = await app.f7.request.promise.post(URLS.GetAvailRoomsForEdit, {
              object
            }).then(res => {
              var roomslist = JSON.parse(res.data);
              app.f7.preloader.hide();
              app.f7.stepper.get('.quest_stepper').max = roomslist.MaxAdults;
              app.f7.stepper.get('.children_stepper').max = roomslist.MaxChildren;
              self.$setState({
                RoomsList: roomslist,
                RateList: roomslist,
                RoomCatsList: roomslist.RoomCatsList
              }).then(x => {
                var tmpRoomCategory = $$("#hRoomCategoryID").val();
                var tmpRoom = $$("#hRoomID").val();
                var tmpRate = $$("#hRateID").val();
                app.f7.smartSelect.get('#smartselectroomcategory').setValue(tmpRoomCategory);
                app.f7.smartSelect.get('.smartselectroom').setValue(tmpRoom);
                app.f7.smartSelect.get('.smartselectroomrate').setValue(tmpRate);
              });
            });
          } catch {}
        }
      });
      $$('#editbtnnewforguest1').on('click', async () => {
        var regfresh = $$('#editbtnnewforguest1').attr('data-refresh');

        if (regfresh == 1) {
          try {
            var obj = {
              PropertyID: self.PropertyID,
              UserID: self.UserID,
              ReservationID: reservId
            };
            app.f7.views.main.router.navigate(app.f7.views.main.router.currentRoute.url, {
              reloadCurrent: true,
              ignoreCache: true
            });
          } catch (error) {
            console.log(error);
          }
        } else {
          $$('.guest .disabled').each(function () {
            $$(this).removeClass("disabled", false);
          });
          $$('#questsbtnSave').show();
          $$('#editbtnnewforguest1').attr("data-refresh", 1);
          $$('#editbtnnewforguest1').text("Cancel");
          const UserSpecificApiKey = loginobject?.PropertiesList?.find(property => property.PropertyName == loginobject?.PropertyName)?.UserSpecificApiKey;
          var object = {
            ReservationID: reservId,
            PropertyID: self.PropertyID,
            RoomCategory: RoomCategory,
            DateTo: DateTo,
            DateFrom: DateFrom,
            UserSpecificApiKey: UserSpecificApiKey
          };

          try {
            app.f7.preloader.show();
            let response = await app.f7.request.promise.post(URLS.GetAvailRoomsForEdit, {
              object
            }).then(res => {
              var roomslist = JSON.parse(res.data);
              var ratelist = roomslist;
              app.f7.preloader.hide();
              self.$setState({
                RoomsList: roomslist,
                RateList: ratelist,
                RoomCatsList: roomslist.RoomCatsList
              });
            });
          } catch {}
        }
      });
      $$('#editbtnnewforlinkedProfiles').on('click', async () => {
        var regfresh = $$('#editbtnnewforlinkedProfiles').attr('data-refresh');

        if (regfresh == 1) {
          try {
            var obj = {
              PropertyID: self.PropertyID,
              UserID: self.UserID,
              ReservationID: reservId
            };
            app.f7.views.main.router.navigate(app.f7.views.main.router.currentRoute.url, {
              reloadCurrent: true,
              ignoreCache: true
            });
          } catch (error) {
            console.log(error);
          }
        } else {
          $$('.linked-profiles').each(function () {
            $$(this).removeClass("disabled", false);
          });
          $$('#linkedProfilesbtnSave').show();
          $$('#editbtnnewforlinkedProfiles').attr("data-refresh", 1);
          $$('#editbtnnewforlinkedProfiles').text("Cancel");
          var object = {
            ReservationID: reservId,
            PropertyID: self.PropertyID,
            RoomCategory: RoomCategory,
            DateTo: DateTo,
            DateFrom: DateFrom
          };
        }
      });
      var today = moment().startOf('day').format('YYYY-MM-DD');
      var tomorrow = moment(today).add(1, 'day'); //CalendarForm

      var calendarRangeFrom = app.f7.calendar.create({
        inputEl: '.editdatesin',
        dateFormat: 'yyyy-mm-dd',
        closeOnSelect: true,
        on: {
          change: function (calendar, value) {
            var selectedInDate = moment(value[0]).format('ddd DD/MM/YYYY');
            $$('.editdatesin').text(selectedInDate);
            var inDate = moment(value[0]);
            var outDate = moment($$('.editdatesout').text(), 'ddd DD/MM/YYYY');

            if (!outDate.isValid() || inDate.isAfter(outDate)) {
              var newOutDate = inDate.add(1, 'day'); // Format the selected date for display

              var selectedInDate = moment(value[0]).format('ddd DD/MM/YYYY');
              $$('.editdatesin').text(selectedInDate); // Update editdatesout if necessary

              var inDate = moment(value[0]);
              var outDate = moment(newOutDate); // Update the calendarOut to reflect the new minDate

              calendarRangeTo.setValue([newOutDate.toDate()]); // calendarRangeTo.params.minDate = inDate.toDate();
              // calendarRangeTo.update();

              getAvailRoomsForDates();
              $$('.editdatesout').text(newOutDate.format('ddd DD/MM/YYYY'));
            }
          }
        }
      });

      if (transferTypeSheet) {
        transferTypeSheet.on("open", async () => {
          calendarTransferDate.close();
          TransferCalCheckOpen = false;
        });
        transferTypeSheet.on("close", async () => {
          TransferCalCheckOpen = false;
        });
      }

      if (transferCategorySheet) {
        transferCategorySheet.on("open", async () => {
          calendarTransferDate.close();
          TransferCalCheckOpen = false;
        });
        transferCategorySheet.on("close", async () => {
          TransferCalCheckOpen = false;
        });
      }

      if (transferSheet) {
        transferSheet.on("close", async () => {
          calendarTransferDate.close();
          TransferCalCheckOpen = false;
        });
      }

      var calendarTransferDate = app.f7.calendar.create({
        inputEl: '#AddTransferDate',
        timePicker: true,
        dateFormat: 'dd/mm/yyyy, hh::mm',
        closeOnSelect: true,
        footer: true
      });
      $$(".transfer-sheet").on('click', function () {// if (TransferCalCheckOpen && TransferCalCheckOpen == true) {
        //   calendarTransferDate.close();
        //   TransferCalCheckOpen = false;
        // }
      });
      calendarTransferDate.on("open", async () => {
        TransferCalCheckOpen = true;
      });
      var CalendarDateFrom = calendarRangeFrom.getValue();
      var calendarRangeTo = app.f7.calendar.create({
        inputEl: '.editdatesout',
        dateFormat: 'yyyy-mm-dd',
        closeOnSelect: true,
        on: {
          change: function (calendar, value) {
            var selectedInDate = moment(value[0]).format('ddd DD/MM/YYYY');
            $$('.editdatesout').text(selectedInDate);
            var inDate = moment(value[0]);
            var outDate = moment($$('.editdatesin').text(), 'ddd DD/MM/YYYY');

            if (!inDate.isValid() || outDate.isAfter(inDate)) {
              var newOutDate = inDate.add(-1, 'day'); // Format the selected date for display

              var selectedInDate = moment(value[0]).format('ddd DD/MM/YYYY');
              $$('.editdatesout').text(selectedInDate); // Update editdatesout if necessary

              var inDate = moment(value[0]);
              var outDate = moment(newOutDate); // Update the calendarOut to reflect the new minDate

              calendarRangeFrom.setValue([newOutDate.toDate()]); // calendarRangeFrom.params.minDate = newOutDate.toDate();
              // calendarRangeTo.update();

              getAvailRoomsForDates();
              $$('.editdatesin').text(newOutDate.format('ddd DD/MM/YYYY'));
            }
          }
        }
      });

      async function getAvailRoomsForDates() {
        DateFrom = calendarRangeFrom.getValue();
        DateTo = calendarRangeTo.getValue();
        var datefrom = DateFrom ? moment(DateFrom.toString()).format('DD/MM/YYYY') : moment($$('.editdatesin').html().split(" ")[1], "DD/MM/YYYY").format('DD/MM/YYYY');
        var dateto = DateTo ? moment(DateTo.toString()).format('DD/MM/YYYY') : moment($$('.editdatesout').html().split(" ")[1], "DD/MM/YYYY").format('DD/MM/YYYY');
        var ReservationID = customerReservation?.ReservationID;
        const UserSpecificApiKey = loginobject?.PropertiesList?.find(property => property.PropertyName == loginobject?.PropertyName)?.UserSpecificApiKey;
        var object = {
          ReservationID: ReservationID,
          PropertyID: self.PropertyID,
          RoomCategory: RoomCategory,
          DateTo: dateto,
          DateFrom: datefrom,
          UserSpecificApiKey: UserSpecificApiKey
        };

        try {
          app.f7.preloader.show();
          let response = await app.f7.request.promise.post(URLS.GetAvailRoomsForEdit, {
            object
          });
          var roomslist = JSON.parse(response.data);
          var ratelist = roomslist;

          if (roomslist == "ErrorDates") {
            var toastWithCustomButton = app.f7.toast.create({
              text: 'Please check your Reservation Details',
              closeButton: true,
              closeButtonText: 'Close Me',
              closeButtonColor: 'red',
              closeTimeout: 3000
            });
            toastWithCustomButton.open();
            app.f7.preloader.hide();
            return;
          }

          self.$setState({
            RoomsList: roomslist,
            RoomCatsList: roomslist.RoomCatsList
          }).then(res => {
            var tmpRoomCategory = $$("#hRoomCategoryID").val();
            var tmpRoom = $$("#hRoomID").val();
            var tmpRate = $$("#hRateID").val();

            if (tmpRoomCategory && roomslist.RoomCatsList.filter(function (e) {
              return e.Key == tmpRoomCategory;
            }).length > 0) {
              app.f7.smartSelect.get('.smartselectroomcategory1').setValue(tmpRoomCategory);

              if (tmpRoom && roomslist.RoomsList.filter(function (e) {
                return e.Key == tmpRoom;
              }).length > 0) {
                app.f7.smartSelect.get('.smartselectroom').setValue(tmpRoom);
              } else if (roomslist.RoomsList.length > 1) {
                app.f7.smartSelect.get('.smartselectroom').setValue(roomslist.RoomsList[1].Key);
              } else {
                app.f7.smartSelect.get('.smartselectroom').setValue(roomslist.RoomsList[0].Key);
              }
            } else {
              app.f7.smartSelect.get('.smartselectroomcategory1').setValue(roomslist.RoomCatsList[0].Key);

              if (roomslist.RoomsList.length > 1) {
                app.f7.smartSelect.get('.smartselectroom').setValue(roomslist.RoomsList[1].Key);
              } else {
                app.f7.smartSelect.get('.smartselectroom').setValue(roomslist.RoomsList[0].Key);
              }
            }

            if (tmpRate && roomslist.RatesList.filter(function (e) {
              return e.Key == tmpRate;
            }).length > 0) {
              app.f7.smartSelect.get('.smartselectroomrate').setValue(tmpRate);
            } else {
              app.f7.smartSelect.get('.smartselectroomrate').setValue(roomslist.RatesList[0].Key);
            }
          });
          app.f7.preloader.hide();
        } catch (error) {
          console.log(error);
        }
      }

      $$('#editbtnnewdatesout').on('click', function () {// $('.editdatesout').prop("disabled",false);
        // $(".editdatesout").focus();
      });
      $$('#editbtnnewroomcategory').on('click', function () {
        $('.editroomcat').prop("disabled", false);
        $(".editroomcat").focus();
      });
      $$('#editbtnnewratename').on('click', function () {
        $('.editratename').prop("disabled", false);
        $(".editratename").focus();
      });
      $$('#editbtnnewroom').on('click', function () {
        $('.editroom').prop("disabled", false);
        $(".editroom").focus();
      });
      $$('.editbtnnewpricepernight').on('click', function () {
        var currprice = $('#curprice').text();
        currprice = currprice.replace("€", "").replace(" ", "");
        var dynamicSheet = app.f7.sheet.create({
          content: `
                            <div class="sheet-modal" style="height:71px; ">
                            
                                <div class="sheet-modal-inner">
                                    <div class="sheet-modal-swipe-step">
                                    <div class="display-flex padding justify-content-space-between align-items-center">
                                    <div style="font-size: 16px"><b>Price Per Night:</b></div>
                                    
                                    <input type="number" value="` + Number(currprice) + `" class="the-price" id="newprice"  data-label= "true" min="0" max="" required validate pattern="[0-9]* data-error-message="Only numbers please!" style="font-size: 15px; width:48%; border-bottom:1px solid grey;"/><b id="roomprice_{{RoomTypeID}}"> <a class="link sheet-close" style="color:black;">Save</a> </b>                                    
                                </div>
                                </div>
                                </div>
                            </div>
                            `,
          on: {
            close: function (sheet) {
              var newprice = $('#newprice').val();
              var updprice = $('#curprice').text(newprice + "€");
              var checkin = $('.editdatesin').text();
              var checkout = $('.editdatesout').text();
              var chin = moment(checkin.split(" ")[1], "DD/MM/YYYY");
              var checko = moment(checkout.split(" ")[1], "DD/MM/YYYY");
              var nights = checko.diff(chin, "days");
              var newtotal = $('#curprice2').text(nights * newprice + "€");
            }
          }
        });
        dynamicSheet.open();
        $('.editprice').prop("disabled", false);
        $(".editprice").focus();
      });
      $$('.editbtnnewtotalprice').on('click', function () {
        var currprice = $('#curprice2').text();
        var c = $('#curprice2').text().replace("€", "").replace(" ", "");
        ;
        var dynamicSheet = app.f7.sheet.create({
          content: `
                    <div class="sheet-modal" style="height:71px; ">
                    
                        <div class="sheet-modal-inner">
                            <div class="sheet-modal-swipe-step">
                            <div class="display-flex padding justify-content-space-between align-items-center">
                            <div style="font-size: 16px"><b> Total Price:</b></div>
                            
                            <input type="number" value="` + Number(c) + `" class ="the-price" id="newtotalprice"  data-label= "true" min="" max="" required validate pattern="[0-9]* data-error-message="Only numbers please!" style="font-size: 15px; width:48%; border-bottom:1px solid grey;"/><b id="roomprice_{{RoomTypeID}}"> <a class="link sheet-close" style="color:black;">Save</a> </b>   
                        </div>
                        </div>
                        </div>
                    </div>
                    `,
          on: {
            close: function (sheet) {
              var newtotalprice = $('#newtotalprice').val();
              var updtotalprice = $('#curprice2').text(newtotalprice + "€");
            }
          }
        });
        dynamicSheet.open();
      });
      $$('.noteIcon').on('click', function () {
        var container = $$('.page-content'),
            scrollTo = $$('#noteId');
        container.scrollTop(scrollTo.offset().top - container.offset().top + container.scrollTop(), 600);
        $$('.notes').addClass('accordion-item-opened');
      });
      $$('.profileIcon').on('click', function () {
        var container2 = $$('.page-content'),
            scrollTo = $$('#guestId');
        container2.scrollTop(scrollTo.offset().top - container2.offset().top + container2.scrollTop(), 600);
        $$('.guest').addClass('accordion-item-opened');
      });
      $$('.reservIcon').on('click', function () {
        var container3 = $$('.page-content'),
            scrollTo = $$('#roomId');
        container3.scrollTop(scrollTo.offset().top - container3.offset().top + container3.scrollTop(), 600);
        $$('.roomdetails').addClass('accordion-item-opened');
      });
      $$('.editNote1').on('click', function () {
        $('.noteReservation').prop("disabled", false);
        $(".noteReservation").focus();
      });
      $$('.editNote2').on('click', function () {
        $('.noteCompany').prop("disabled", false);
        $(".noteCompany").focus();
      });
      $$('.editNote3').on('click', function () {
        $('.noteFolio').prop("disabled", false);
        $(".noteFolio").focus();
      });
      $$('.doEdit').on('click', function () {
        $('.doEdit').css("display", "none");
        $('.edbt').css("display", "block");
        $('.edbt2').css("display", "block");
        $('.edbt3').css("display", "block");
        $('.edbt5').css("display", "block");
      });
      $$('.edbt').on('click', function () {
        $('.privateInfo').prop("disabled", false);
        $('.privateInfo').focus();
      });
      $$('.edbt5').on('click', function () {
        $('.privateInfo2').prop("disabled", false);
        $('.privateInfo2').focus();
      });
      $$('.edbt3').on('click', function () {
        $('.takephone').prop("disabled", false);
        $('.takephone').focus();
      });
      $$('#questsbtnSave').on('click', async function () {
        var GuestInfo1name = $$('input[name="GuestInfo1name"]').val();
        var GuestInfo1Surname = $$('input[name="GuestInfo1Surname"]').val();
        var GuestInfo1Email = $$('input[name="GuestInfo1Email"]').val();
        var GuestInfo1Phone = $$('input[name="GuestInfo1Phone"]').val();
        var GuestInfo2Name = $$('input[name="GuestInfo2Name"]').val();
        var GuestInfo2Surname = $$('input[name="GuestInfo2Surname"]').val();
        var countryDropdownGuest1 = $$('#countryDropdownGuest1').val();
        var countryDropdownGuest2 = $$('#countryDropdownGuest2').val();

        if (customerReservation?.CancelPolList) {
          var selectedCancellationPolicie = app.f7.smartSelect.get('.showsmartselect').getValue();
          var selectedPaymentPolicie = app.f7.smartSelect.get('.showsmartselect2').getValue();
          var selectedRoomCategory = app.f7.smartSelect.get('.smartselectroomcategory1').getValue();
          var selectedRoomRate = app.f7.smartSelect.get('.smartselectroomrate').getValue();
          var selectedRoomID = app.f7.smartSelect.get('.smartselectroom').getValue();
        }

        var updprice = $('#curprice').text();
        var updtotalprice = $('#curprice2').text();
        updprice = updprice.replace('€', '');
        var whatsWrongMessage = "";

        if (!selectedRoomCategory) {
          whatsWrongMessage = "Please select a room category";
        }

        if (!selectedRoomRate) {
          whatsWrongMessage = "Please select a rate";
        }

        if (!selectedRoomID) {
          whatsWrongMessage = "Please select a room";
        }

        if (whatsWrongMessage) {
          var toastCheckConnection = app.f7.toast.create({
            text: whatsWrongMessage,
            position: "center",
            closeTimeout: 2500
          }).open();
          return;
        }

        var DateFrom = calendarRangeFrom.getValue();
        var DateTo = calendarRangeTo.getValue();
        var datefrom = DateFrom ? moment(DateFrom.toString()).format('DD/MM/YYYY') : moment($$('.editdatesin').html().split(" ")[1], "DD/MM/YYYY").format('DD/MM/YYYY');
        var dateto = DateTo ? moment(DateTo.toString()).format('DD/MM/YYYY') : moment($$('.editdatesout').html().split(" ")[1], "DD/MM/YYYY").format('DD/MM/YYYY');
        var obj = {
          PropertyID: self.PropertyID,
          UserID: self.UserID,
          CustomId: CustomId,
          reservId: reservId,
          RateID: selectedRoomRate,
          RoomID: selectedRoomID,
          ReservationID: reservId,
          GuestName1: GuestInfo1name,
          GuestSurname1: GuestInfo1Surname,
          GuestCountry1: countryDropdownGuest1,
          GuestName2: GuestInfo2Name,
          GuestSurname2: GuestInfo2Surname,
          GuestCountry2: countryDropdownGuest2,
          GuestPhone1: GuestInfo1Phone,
          GuestEmail1: GuestInfo1Email
        };

        try {
          app.f7.preloader.show();
          let response = await app.f7.request.promise.postJSON(URLS.EditReservationGuests, {
            obj
          });
          app.f7.preloader.hide();

          if (response.data === "Ok") {
            app.f7.views.main.router.navigate(app.f7.views.main.router.currentRoute.url, {
              reloadCurrent: true
            });
          } else {
            var toastWithCustomButton = app.f7.toast.create({
              text: 'Please check your Guests Details',
              closeButton: true,
              closeButtonText: 'Close Me',
              closeButtonColor: 'red'
            });
            toastWithCustomButton.open();
          }
        } catch (error) {
          app.f7.preloader.hide();
          console.log(error);
        }
      });
      $$('#linkedProfilesbtnSave').on('click', async function () {
        var selectedCompany = app.f7.smartSelect.get('#smartselectcompany').getValue();
        var selectedAgency = app.f7.smartSelect.get('#smartselectagency').getValue();
        var selectedTourism = app.f7.smartSelect.get('#smartselecttourism').getValue();
        var obj = {
          PropertyID: self.PropertyID,
          UserID: self.UserID,
          CustomId: CustomId,
          ReservationID: reservId,
          CompanyID: selectedCompany,
          AgencyID: selectedAgency,
          ContractID: selectedTourism
        };

        try {
          app.f7.preloader.show();
          let response = await app.f7.request.promise.postJSON(URLS.SubmitLinkedProfiles, {
            obj
          });
          app.f7.preloader.hide();

          if (response.data === "Ok") {
            app.f7.views.main.router.navigate(app.f7.views.main.router.currentRoute.url, {
              reloadCurrent: true
            });
          } else {
            var toastWithCustomButton = app.f7.toast.create({
              text: 'Please check your Linked Profile Details',
              closeButton: true,
              closeButtonText: 'Close Me',
              closeButtonColor: 'red'
            });
            toastWithCustomButton.open();
          }
        } catch (error) {
          app.f7.preloader.hide();
        }
      });
      $$('#ResDetailsbtnSave').on('click', async function () {
        if (customerReservation?.CancelPolList) {
          var selectedCancellationPolicie = app.f7.smartSelect.get('.showsmartselect').getValue();
          var selectedPaymentPolicie = app.f7.smartSelect.get('.showsmartselect2').getValue();
          var selectedRoomCategory = app.f7.smartSelect.get('.smartselectroomcategory1').getValue();
          var selectedRoomRate = app.f7.smartSelect.get('.smartselectroomrate').getValue();
          var selectedRoomID = app.f7.smartSelect.get('.smartselectroom').getValue();
          var Guests = app.f7.smartSelect.get('.showsmartselect').getValue();
          var Guests = app.f7.stepper.get('.quest_stepper').getValue();
          var Childrens = app.f7.stepper.get('.children_stepper').getValue();
        }

        var whatsWrongMessage = "";

        if (!selectedRoomCategory) {
          whatsWrongMessage = "Please select a room category";
        }

        if (!selectedRoomRate) {
          whatsWrongMessage = "Please select a rate";
        }

        if (!selectedRoomID) {
          whatsWrongMessage = "Please select a room";
        }

        if (whatsWrongMessage) {
          var toastCheckConnection = app.f7.toast.create({
            text: whatsWrongMessage,
            position: "center",
            closeTimeout: 2500
          }).open();
          return;
        }

        var updprice = $('#curprice').text();
        var updtotalprice = $('#curprice2').text();
        updprice = updprice.replace('€', '');
        var DateFrom = calendarRangeFrom.getValue();
        var DateTo = calendarRangeTo.getValue();
        var datefrom = DateFrom ? moment(DateFrom.toString()).format('DD/MM/YYYY') : moment($$('.editdatesin').html().split(" ")[1], "DD/MM/YYYY").format('DD/MM/YYYY');
        var dateto = DateTo ? moment(DateTo.toString()).format('DD/MM/YYYY') : moment($$('.editdatesout').html().split(" ")[1], "DD/MM/YYYY").format('DD/MM/YYYY');
        var obj = {
          PropertyID: self.PropertyID,
          UserID: self.UserID,
          CustomId: CustomId,
          reservId: reservId,
          RoomCategoryID: selectedRoomCategory,
          RateID: selectedRoomRate,
          DateFrom: datefrom,
          DateTo: dateto,
          PricePerNight: updprice,
          ReservationID: reservId,
          RoomID: selectedRoomID,
          Adults: Guests,
          Children: Childrens
        };

        try {
          app.f7.preloader.show();
          let response = await app.f7.request.promise.postJSON(URLS.EditReservationDetails, {
            obj
          });
          app.f7.preloader.hide();
          let responseText = "Ok";

          if (response.data === "Ok") {
            $$("#hRoomCategoryID").val(selectedRoomCategory);
            $$("#hRoomID").val(selectedRoomID);
            $$("#hRateID").val(selectedRoomRate);
            app.f7.views.main.router.navigate(app.f7.views.main.router.currentRoute.url, {
              reloadCurrent: true
            });
          } else if (response.data === "OverGuests") {
            responseText = "More guests than room the allows";
          } else if (response.data === "OverAdults") {
            responseText = "More adults than room the allows";
          } else if (response.data === "OverChildren") {
            responseText = "More children than room the allows";
          } else if (response.data === "UnderGuests") {
            responseText = "Totan pax under minimun";
          } else if (response.data === "UnderAdults") {
            responseText = "Adults have to be more than 0";
          } else if (response.data === "CantChangePrice") {
            responseText = "Folio nights are closed you cant change price";
          }

          if (responseText != "Ok") {
            var toastCheckConnection = app.f7.toast.create({
              text: responseText,
              position: "center",
              closeTimeout: 2500
            }).open();
          }
        } catch (error) {
          app.f7.preloader.hide();
          console.log(error);
        }
      });
      $$('#InformationSaveBtn').on('click', async function () {
        $('.doEdit').css("display", "block");
        $('.takeemail').prop("disabled", true);
        $('.takephone').prop("disabled", true);
        $('.privateInfo').prop("disabled", true);
        $('.edbt').css("display", "none");
        $('.edbt2').css("display", "none");
        $('.edbt3').css("display", "none");
        $('.edbt5').css("display", "none");

        if (customerReservation?.CancelPolList) {
          var selectedCancellationPolicie = app.f7.smartSelect.get('.showsmartselect').getValue();
          var selectedPaymentPolicie = app.f7.smartSelect.get('.showsmartselect2').getValue();
          var selectedRoomCategory = app.f7.smartSelect.get('.smartselectroomcategory1').getValue();
          var selectedRoomRate = app.f7.smartSelect.get('.smartselectroomrate').getValue();
          var selectedRoomID = app.f7.smartSelect.get('.smartselectroom').getValue();
          var whatsWrongMessage = "";

          if (!selectedRoomCategory) {
            whatsWrongMessage = "Please select a room category";
          }

          if (!selectedRoomRate) {
            whatsWrongMessage = "Please select a rate";
          }

          if (!selectedRoomID) {
            whatsWrongMessage = "Please select a room";
          }

          if (whatsWrongMessage) {
            var toastCheckConnection = app.f7.toast.create({
              text: whatsWrongMessage,
              position: "center",
              closeTimeout: 2500
            }).open();
            return;
          }
        }

        var updprice = $('#curprice').text();
        var updtotalprice = $('#curprice2').text();
        var $inputs = $('.card :input');
        var values = {};
        $inputs.each(function () {
          values[this.name] = $(this).val();
        });
        var DateFrom = calendarRangeFrom.getValue();
        var DateTo = calendarRangeTo.getValue();
        var datefrom = DateFrom ? moment(DateFrom.toString()).format('DD/MM/YYYY') : moment($$('.editdatesin').html().split(" ")[1], "DD/MM/YYYY").format('DD/MM/YYYY');
        var dateto = DateTo ? moment(DateTo.toString()).format('DD/MM/YYYY') : moment($$('.editdatesout').html().split(" ")[1], "DD/MM/YYYY").format('DD/MM/YYYY');
        var obj = {
          PropertyID: self.PropertyID,
          UserID: self.UserID,
          CustomId: CustomId,
          reservId: reservId,
          RoomCategoryID: selectedRoomCategory,
          RateID: selectedRoomRate,
          RoomID: selectedRoomID,
          DateFrom: datefrom,
          DateTo: dateto,
          PricePerNight: updprice
        };

        try {
          app.f7.preloader.show();
          let response = await app.f7.request.promise.postJSON(URLS.EditReservationDetails, {
            obj
          });
          app.f7.preloader.hide();

          if (response.data === "OK") {
            app.f7.preloader.show();
            let response = await app.f7.request.promise.postJSON(URLS.GetReservationDetails, {
              obj
            });
            app.f7.preloader.hide();
            self.$setState({
              AllRoomsList: response.data.AllRoomCategories
            });
          }
        } catch (error) {
          console.log(error);
        }
      });
      $$('#CheckInReservation').on('click', async function () {
        app.f7.dialog.confirm('Are you sure you want to check in this reservation?', "", async function () {
          var ReservationID = customerReservation?.ReservationID;
          var obj = {
            PropertyID: self.PropertyID,
            UserID: self.UserID,
            ReservationID: ReservationID
          };
          let responseText = "Check in failed";

          try {
            app.f7.preloader.show();
            let response = await app.f7.request.promise.postJSON(URLS.CheckInTheReservation, {
              obj
            });
            app.f7.preloader.hide();
            var otherReservationIDInRoom = "";

            if (response.data == "NeedAssign") {
              responseText = "You need to assign the reservation to a room first";
            } else if (response.data == "NotFuture") {
              responseText = "Its too early to check in";
            } else if (response.data == "Parked") {
              responseText = "This reservation is parked in a help row";
            } else if (response.data == "AssignCustomer") {
              responseText = "You need to assign a customer to this reservation first";
            } else if (response.data == "Ok") {
              responseText = "Check in successful";
            } else if (response.data == "Error") {
              responseText = "Check in failed";
            } else if (response.data == "CheckedOut") {
              responseText = "This reservation has already been checked out";
            } else {
              if (response.data.split(',')[0] == self.ReservationInformation.ResID) {
                responseText = "This reservation is already checked in";
              } else {
                responseText = "Another customer is already checked in: " + response.data.split(',')[0];
                otherReservationIDInRoom = response.data.split(',')[1];
              }
            }
          } catch (error) {
            console.log(error);
          }

          if (otherReservationIDInRoom) {
            app.f7.dialog.create({
              title: '',
              text: responseText,
              buttons: [{
                text: 'Cancel',
                close: true
              }, {
                text: 'Go to Reservation',
                onClick: function () {
                  localStorage.setItem("ReservationID", JSON.stringify(otherReservationIDInRoom));
                  app.f7.views.main.router.navigate('/reservation-info/', {
                    transition: 'f7-dive',
                    reloadCurrent: true
                  });
                }
              }]
            }).open();
          } else {
            app.f7.dialog.alert(responseText, "");
          }
        });
      });
      $$('#CheckOutReservation').on('click', async function () {
        app.f7.dialog.confirm('Are you sure you want to check out this reservation?', "", async function () {
          let responseText = "Can't checkout";
          var ReservationID = customerReservation?.ReservationID;
          var obj = {
            PropertyID: self.PropertyID,
            UserID: self.UserID,
            ReservationID: ReservationID
          };

          try {
            app.f7.preloader.show();
            let response = await app.f7.request.promise.postJSON(URLS.CheckOutTheReservation, {
              obj
            });
            app.f7.preloader.hide();

            if (response.data == "TooEarly") {
              responseText = "It's too early to check out";
            } else if (response.data == "CheckIn") {
              responseText = "This reservation has not been checked in yet";
            } else if (response.data.includes("OK_")) {
              responseText = "Checkout successful";
            } else {
              var owedFolios = response.data.split("**")[0];
              responseText = "Can't checkout";
              responseText += owedFolios && " close folios " + owedFolios;
            }
          } catch (error) {
            console.log(error);
          }

          app.f7.dialog.alert(responseText, "");
        });
      });
      $("#cancelRadioCheckOne").trigger("change");
      $$('#cancelRadioCheckOne').change(function () {
        $$('#cancelRadioCheckTwo').prop('checked', false);
        $$('#cancelRadioCheckOne').prop('checked', true);
        $$("#CancellationFee").prop('disabled', true);
        $$("#CancellationFee").css("opacity", "0.3");
        $$(".LightOnCharge").css("opacity", "1");
        $$("#hCancelationFeeType").val("1");
      });
      $$('#cancelRadioCheckTwo').change(function () {
        $$('#cancelRadioCheckOne').prop('checked', false);
        $$('#cancelRadioCheckTwo').prop('checked', true);
        $$("#CancellationFee").prop('disabled', false);
        $$("#CancellationFee").css("opacity", "1");
        $$(".LightOnCharge").css("opacity", "0.3");
        $$("#hCancelationFeeType").val("2");
      });
      $$('#CancelReservation').on('click', async function () {
        var ReservationID = localStorage.getItem('ReservationID');
        ReservationID = JSON.parse(ReservationID);
        var tmpCnclTp = 1;
        var ChannelManagerIDCheck = $$('#hChannelManagerID').val();

        if (tmpCnclTp != '1' && tmpCnclTp != 1) {
          ChannelManagerIDCheck = 2;
        }

        app.f7.preloader.show();
        await app.f7.request.promise.post(URLS.ShowCancelFees, {
          ReservationID: ReservationID,
          CancelType: ChannelManagerIDCheck,
          PropertyID: self.PropertyID
        }).then(res => {
          var cancelRes = JSON.parse(res.data);
          $$('#CancelResID').html(cancelRes.ResID);
          $$('#CancelBookingDate').html(cancelRes.BookDateStr);
          $$('#CancelSource').html(cancelRes.Source);
          $$('#CancelCheckinOut').html(cancelRes.CheckinDateStr + " - " + cancelRes.CheckoutDateStr);
          $$('#CancelCustomer').html(cancelRes.CustomerName);
          $$('#CancelReservationCharges').html(cancelRes.TotalPrice);
          $$('#CancelRateName').html(cancelRes.RateName);
          $$('#CancelTotalCharge').html(cancelRes.TotalPrice);
          $$('#CancellationFee').val(cancelRes.CancellationFee);
          $$('#CancelCancelationPolicy').html(cancelRes.CancellationPolicyText);
          var tmpButtonHtml = "";

          if (ChannelManagerIDCheck == 1) {
            tmpButtonHtml = "Cancel Reservation";
            $$("#CancelReservationButton").removeClass("primaryButtonCons");
            $$("#CancelReservationButton").removeClass("dangerButtonCons");
            $$("#CancelReservationButton").addClass("primaryButtonCons");
          } else {
            tmpButtonHtml = "Mark as no show";
            $$("#CancelReservationButton").removeClass("dangerButtonCons");
            $$("#CancelReservationButton").removeClass("primaryButtonCons");
            $$("#CancelReservationButton").addClass("dangerButtonCons");
          }

          $$("#CancelReservationButton").html(tmpButtonHtml);
          app.f7.sheet.open('.my-sheet-cancel', true);
          app.f7.preloader.hide();
        });
      });
      $$("#TransferContjs").on("click", function (e) {
        var id = $$(e.target).attr('id');

        if (id != "AddTransferDate") {
          var sheet = app.f7.sheet.get('.calendar-sheet');

          if (sheet) {
            var opened = sheet.$el.hasClass('modal-in');

            if (opened) {
              app.f7.sheet.close('.calendar-sheet', true);
            }
          }
        }
      });
      $$("#CancelReservationButton").on('click', async function () {
        app.f7.dialog.confirm('Are you sure you want to cancel this reservation?', "", async function () {
          let responseText = "Reservation is canceled";
          var ReservationID = localStorage.getItem('ReservationID');
          ReservationID = JSON.parse(ReservationID);
          var tmpCnclTp = 1;
          var ChannelManagerIDCheck = $$('#hChannelManagerID').val();

          if (tmpCnclTp != '1' && tmpCnclTp != 1) {
            ChannelManagerIDCheck = 2;
          }

          var cancelFeeType = $$('#hCancelationFeeType').val();
          var cancellationFee = $$('#CancellationFee').val();
          var cancellationFeeNotes = $$('#CancellationFeeText').val();
          var obj = {
            PropertyID: self.PropertyID,
            UserID: self.UserID,
            ReservationID: ReservationID,
            CancelFeeType: cancelFeeType,
            CancellationFee: cancellationFee,
            CancellationFeeNotes: cancellationFeeNotes,
            CancelType: ChannelManagerIDCheck
          };

          try {
            app.f7.preloader.show();
            let response = await app.f7.request.promise.postJSON(URLS.SubmitCancellationFees, {
              obj
            });
            app.f7.preloader.hide();

            if (response.data === "Ok") {
              app.f7.views.main.router.navigate(app.f7.views.main.router.currentRoute.url, {
                reloadCurrent: true
              });
              app.f7.sheet.close('.my-sheet-cancel', true);
            } else if (response.data === "ChargesPayments") {
              responseText = "Reservation has charge payments";
            } else if (response.data === "AlreadyCancelled") {
              responseText = "Already cancelled reservation";
            } else if (response.data === "Ok1") {
              FinalCancelReservation(ReservationID);
            } else if (response.data === "Ok11") {
              FinalCancelReservation(ReservationID);
            } else if (response.data === "Ok2") {
              FinalNoShowReservation(ReservationID);
            } else if (response.data === "Ok22") {
              FinalNoShowReservation(ReservationID);
            }
          } catch (error) {
            app.f7.preloader.hide();
            console.log(error);
          }
        });
      });

      async function FinalNoShowReservation(ResID) {
        var UserName = loginobject.FirstName + " " + loginobject.LastName;
        var ReservationID = ResID;
        app.f7.preloader.show();
        let response = await app.f7.request.promise.post(URLS.NoShowReservation, {
          ReservationID: ReservationID,
          PropertyID: self.PropertyID,
          UserID: self.UserID,
          UserName: UserName
        });
        app.f7.preloader.hide();
        response.data = response.data.replace("\"", "");
        response.data = response.data.replace("\"", "");

        if (response.data === "Ok" || response.data === "ErrorWebHotelier" || response.data === "InvalidAuth" || response.data === "ErrorWebHotelierSome") {
          app.f7.views.main.router.navigate(app.f7.views.main.router.currentRoute.url, {
            reloadCurrent: true
          });
          app.f7.sheet.close('.my-sheet-cancel', true);
        } else if (response.data === "MoneyFirst") {
          var toastWithCustomButton = app.f7.toast.create({
            text: 'Reservation needs to be payed (Excluding Accommodation Tax)',
            closeButton: true,
            closeButtonText: 'Close Me',
            closeButtonColor: 'red'
          });
          toastWithCustomButton.open();
        } else {
          var toastWithCustomButton = app.f7.toast.create({
            text: 'Error',
            closeButton: true,
            closeButtonText: 'Close Me',
            closeButtonColor: 'red'
          });
          toastWithCustomButton.open();
        }
      }

      async function FinalCancelReservation(ResID) {
        var UserName = loginobject.FirstName + " " + loginobject.LastName;
        var ReservationID = ResID;
        app.f7.preloader.show();
        let response = await app.f7.request.promise.post(URLS.CancelReservation, {
          ReservationID: ReservationID,
          PropertyID: self.PropertyID,
          UserID: self.UserID,
          UserName: UserName
        });
        app.f7.preloader.hide();
        response.data = response.data.replace("\"", "");
        response.data = response.data.replace("\"", "");

        if (response.data === "Ok" || response.data === "ErrorWebHotelier" || response.data === "InvalidAuth" || response.data === "ErrorWebHotelierSome") {
          if (response.data === "Ok") {
            app.f7.views.main.router.navigate('/main/reservations/', {});
          }

          app.f7.sheet.close('.my-sheet-cancel', true);
        } else if (response.data === "Payments") {
          var toastWithCustomButton = app.f7.toast.create({
            text: 'Reservation has payments.',
            closeButton: true,
            closeButtonText: 'Close Me',
            closeButtonColor: 'red'
          });
          toastWithCustomButton.open();
        } else if (response.data === "Invoices") {
          var toastWithCustomButton = app.f7.toast.create({
            text: 'There are invoices for this reservation!',
            closeButton: true,
            closeButtonText: 'Close Me',
            closeButtonColor: 'red'
          });
          toastWithCustomButton.open();
        } else {
          var toastWithCustomButton = app.f7.toast.create({
            text: 'Error',
            closeButton: true,
            closeButtonText: 'Close Me',
            closeButtonColor: 'red'
          });
          toastWithCustomButton.open();
        }
      }

      function GetCompanyTravelToursimList() {
        var ReservationID = customerReservation?.ReservationID;
        app.f7.preloader.show();
        app.f7.request.promise.post(URLS.GetCompanyTravelToursimList, {
          PropertyID: self.PropertyID,
          ReservationID: ReservationID
        }).then(res => {
          var json = JSON.parse(res.data);
          var companies = json.Companies;
          var agencies = json.Agencies;
          var tourismins = json.Tourismins;
          self.$update(function () {
            self.$setState({
              Companies: companies,
              Agencies: agencies,
              Tourismins: tourismins
            }).then(() => {
              app.f7.smartSelect.get('#smartselectcompany').setValue(customerReservation?.CompanyID);
              app.f7.smartSelect.get('#smartselectagency').setValue(customerReservation?.TravelAgencyID);
              app.f7.smartSelect.get('#smartselecttourism').setValue(customerReservation?.ReservationContractID);
            });
          });
          app.f7.preloader.hide();
        });
      } // $$(".call-now").on('click', async function () {
      //   var phoneNumber = $$(this).data('tel');
      //   window.location.href = 'tel:' + phoneNumber;
      // });


      $(".email-now").on('click', function (event) {
        event.preventDefault();
        var emailAddress = $(this).data('email');
        var mailtoLink = 'mailto:' + emailAddress;

        if (self.isIos()) {
          try {
            cordova.InAppBrowser.open(mailtoLink, "_system", "location=yes");
          } catch {
            window.location.href = mailtoLink;
          }
        } else {
          window.location.href = mailtoLink;
        }
      });
      var currency = await actions.GetUserCurrency();
      $$(".currency-symbol").html(currency);
    },
    pageAfterIn: async function (e, page) {
      $$('#backres').on('click', async () => {
        app.f7.views.main.router.back(app.f7.views.main.router.previousRoute.path, {// ignoreCache: false,  force: true
        });
      });
    },

    pageBeforeRemove() {}

  },
  id: '0cadc4f3b3',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '<div class="page maincontaint" data-name=new-reservation-home><div class=navbar><div class=navbar-bg></div><div class="navbar-inner sliding"><div class=left><a class=link data-ignore-cache=true id=backres data-force=true><i class="icon icon-back"></i></a></div><div class=title>';
      r += Template7Helpers.t.call(ctx_1, 'reservationInfo', {
        hash: {},
        data: data_1 || {},
        fn: function empty() {
          return '';
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</div></div></div><div class=page-content style=background-color:#f7f7f7><div class=card style="padding-bottom: 5px;"><div class=row style="display:flex; align-items:center; justify-content:center;"><div class=col-100 style="padding: 0 7px;"><div style="display: flex;justify-content: space-between;"><div class=privateInfo name=CustomerName style="font-weight:bold; border:none; background-color:white; font-size:20px;" value="" disabled=disabled>';
      r += c(ctx_1.ReservationInformation?.GuestName1, ctx_1);
      r += ' ';
      r += c(ctx_1.ReservationInformation?.GuestSurname1, ctx_1);
      r += '</div>';
      r += Template7Helpers.unless.call(ctx_1, ctx_1.isHouseKeeper, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += ' ';
          r += Template7Helpers.if.call(ctx_2, ctx_2.loginobject?.Communicator, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '<div style="display: flex;align-items: center;width: 45px;" @click="openConversation(';
              r += c(ctx_3.ReservationInformation.ConversationID, ctx_3);
              r += ', ';
              r += c(ctx_3.ReservationInformation.ReservationID, ctx_3);
              r += ');"><div style="position: relative;"><div><svg xmlns=http://www.w3.org/2000/svg x=0px y=0px width=20 height=20 viewBox="0 0 50 50"><path d="M 25 4.0625 C 12.414063 4.0625 2.0625 12.925781 2.0625 24 C 2.0625 30.425781 5.625 36.09375 11 39.71875 C 10.992188 39.933594 11 40.265625 10.71875 41.3125 C 10.371094 42.605469 9.683594 44.4375 8.25 46.46875 L 7.21875 47.90625 L 9 47.9375 C 15.175781 47.964844 18.753906 43.90625 19.3125 43.25 C 21.136719 43.65625 23.035156 43.9375 25 43.9375 C 37.582031 43.9375 47.9375 35.074219 47.9375 24 C 47.9375 12.925781 37.582031 4.0625 25 4.0625 Z M 25 5.9375 C 36.714844 5.9375 46.0625 14.089844 46.0625 24 C 46.0625 33.910156 36.714844 42.0625 25 42.0625 C 22.996094 42.0625 21.050781 41.820313 19.21875 41.375 L 18.65625 41.25 L 18.28125 41.71875 C 18.28125 41.71875 15.390625 44.976563 10.78125 45.75 C 11.613281 44.257813 12.246094 42.871094 12.53125 41.8125 C 12.929688 40.332031 12.9375 39.3125 12.9375 39.3125 L 12.9375 38.8125 L 12.5 38.53125 C 7.273438 35.21875 3.9375 29.941406 3.9375 24 C 3.9375 14.089844 13.28125 5.9375 25 5.9375 Z"></path></svg></div><span class="badge color-red communicator-badge">';
              r += Template7Helpers.if.call(ctx_3, ctx_3.ReservationInformation.NewMessages, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += ' ';
                  r += c(ctx_4.ReservationInformation.NewMessages, ctx_4);
                  r += ' ';
                  return r;
                },
                inverse: function (ctx_4, data_4) {
                  var r = '';
                  r += ' 0 ';
                  return r;
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '</span></div></div>';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += ' ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</div><div class=gendreCountry name=CustomerSurname style="border:none; background-color:white; color:lightslategrey;" value="" disabled=disabled>';
      r += c(ctx_1.ReservationInformation.Country, ctx_1);
      r += '</div></div></div><input hidden id=hRoomCategoryID value=0> <input hidden id=hRoomID value=0> <input hidden id=hEmailID value=0> <input hidden id=hRateID value=0> <input hidden id=hChannelManagerID value=';
      r += c(ctx_1.ReservationInformation.ChannelManagerID, ctx_1);
      r += '> <input hidden id=hCancelationFeeType value=1> ';
      r += Template7Helpers.unless.call(ctx_1, ctx_1.isHouseKeeper, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '<div data-popover=.popover-menu class="row popover-open" style="display:flex; align-items:center; justify-content:center;"><div class=col-80><div class=privateInfo2 name=CustomerSurname style="font-weight:bold;  border:none; background-color:white;" value="" disabled=disabled>Mobile</div><div class=infclass><div class=takephone name=CustomerPhone style="font-size:smaller;  width:100%; background-color:white; border:none;pointer-events: none;" disabled=disabled>';
          r += c(ctx_2.ReservationInformation.GuestPhone1, ctx_2);
          r += '</div></div></div><div class=col-20><div class="external call-now"><i class="icon material-icons md-only">call</i></div></div></div><div class=row style="display:flex; align-items:center; justify-content:center;"><div class=col-80><div class=privateInfo2 name=CustomerSurname style="font-weight:bold;  border:none; background-color:white;" value="" disabled=disabled>Email</div><div class=infclass>';
          r += Template7Helpers.if.call(ctx_2, ctx_2.ReservationInformation.GuestEmail1, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '<div class=takeemail name=CustomerEmail style="font-size:smaller;  width:100%; border:none; background-color:white;" value="" disabled=disabled>';
              r += c(ctx_3.ReservationInformation.GuestEmail1, ctx_3);
              r += '</div><span class="material-icons edbt2" style="font-size:14px; position:absolute; left:100%; display:none;">edit </span>';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '</div><a class=doSave style="color:red; position:absolute; right:0px; border:none;  display:inline-block; width:7%; background-color:white; display:none;" value=Edit disabled=disabled>Save</a></div><div class=col-20><div class=col-20><a class="external email-now" href=# data-email=';
          r += c(ctx_2.ReservationInformation.GuestEmail1, ctx_2);
          r += '><i class="icon material-icons md-only">message</i></a></div></div></div>';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</div><div style="display: flex;flex-direction: column;padding: 0px 14px;"><div style="font-weight: bold; color:black; font-size:initial;">About this reservation - Room ';
      r += c(ctx_1.ReservationInformation.Room, ctx_1);
      r += '</div><span>';
      r += c(ctx_1.ReservationInformation.ResID, ctx_1);
      r += '</span></div><div class=card><div class="card-content card-content-padding"><div class=row style="position: relative;"><div class=checkedin>Check-in<div class=col-50 style=font-weight:bold;>';
      r += c(ctx_1.ReservationInformation.CheckInDateString, ctx_1);
      r += '</div>';
      r += c(ctx_1.ReservationInformation.CheckInTimeString, ctx_1);
      r += '</div><br><br><div class="divider col-10" style="border-left:1px solid #c9d759; width:2px; height:45px; position:absolute; bottom:0; left:50%;"></div><div class="col-45 checkedout">Check-out<div class="" style=font-weight:bold;>';
      r += c(ctx_1.ReservationInformation.CheckOutDateString, ctx_1);
      r += '</div>';
      r += c(ctx_1.ReservationInformation.CheckOutTimeString, ctx_1);
      r += '</div></div><br><div><div class=row><span class=material-icons>room </span>';
      r += Template7Helpers.if.call(ctx_1, ctx_1.ReservationInformation?.SplitRoomStatusStr, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '<div class=col-90 style="font-size: 12px;">';
          r += c(ctx_2.ReservationInformation?.SplitRoomStatusStr, ctx_2);
          r += '</div>';
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += '<div class=col-90>';
          r += c(ctx_2.ReservationInformation.Room, ctx_2);
          r += '</div>';
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</div><div class=row><span class=material-icons>person </span><span class=col-90>';
      r += c(ctx_1.ReservationInformation.Adults, ctx_1);
      r += ' adults, ';
      r += c(ctx_1.ReservationInformation.Children, ctx_1);
      r += ' children, ';
      r += c(ctx_1.ReservationInformation.Infants, ctx_1);
      r += ' infants</span></div><div class=row><span class=material-icons>done_all </span><span class=col-90>';
      r += c(ctx_1.ReservationInformation.Nights, ctx_1);
      r += ' βράδυ, ';
      r += c(ctx_1.ReservationInformation.RoomCategory, ctx_1);
      r += '</span></div>';
      r += Template7Helpers.unless.call(ctx_1, ctx_1.isHouseKeeper, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '<div class=row><span class=material-icons>payment</span><div style="display: flex;font-size: 13px;width: 90%;"><div style="font-weight: 600;margin-right: 10px;">Total reservation:</div><div class="the price" style="display: inline-block;">';
          r += c(ctx_2.ReservationInformation.Currency, ctx_2);
          r += ' ';
          r += c(ctx_2.ReservationInformation.TotalPrice, ctx_2);
          r += '</div></div></div><div class=row><span class=material-icons>account_balance_wallet</span><div style="display: flex;font-size: 13px;width: 90%;justify-content:space-between;"><div style="font-weight: 600;">Payments:</div>';
          r += Template7Helpers.if.call(ctx_2, ctx_2.ReservationInformation.PayedAmount, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '<div class="the price" style="display: inline-block;">';
              r += c(ctx_3.ReservationInformation.Currency, ctx_3);
              r += ' ';
              r += c(ctx_3.ReservationInformation.PayedAmount, ctx_3);
              r += '</div>';
              return r;
            },
            inverse: function (ctx_3, data_3) {
              var r = '';
              r += '<div class="the price" style="display: inline-block;">-</div>';
              return r;
            },
            root: root,
            parents: [ctx_1]
          });
          r += ' ';
          r += Template7Helpers.if.call(ctx_2, ctx_2.ReservationInformation.DepositAmount, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '<div>/</div><div style="font-weight: 600;">Deposit:</div><div class="the price" style="display: inline-block;">';
              r += c(ctx_3.ReservationInformation.Currency, ctx_3);
              r += ' ';
              r += c(ctx_3.ReservationInformation.DepositAmount, ctx_3);
              r += '</div>';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '<div>/</div><div style="font-weight: 600;">Balance:</div><div class="the price" style="display: inline-block;">';
          r += c(ctx_2.ReservationInformation.Currency, ctx_2);
          r += ' ';
          r += c(ctx_2.ReservationInformation.BalanceLeft, ctx_2);
          r += '</div></div></div>';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '<div class=row><span class=material-icons>flight_land </span><span class=col-90 style="display: flex;"><span>Online Check-in</span> ';
      r += Template7Helpers.if.call(ctx_1, ctx_1.ReservationInformation.CompletedOnlineCheckIn, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += ' <i class=material-icons style="margin-left:10px;color: #56c556;">check_circle </i>';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</span></div></div></div></div>';
      r += Template7Helpers.unless.call(ctx_1, ctx_1.isHouseKeeper, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '<div class="accordion-item roomdetails"><div class="accordion-item-toggle Dashboard"><div class=row><div class=col-70 id=roomId>Reservation Details</div><div class=col-10></div><div class=col-20 style="display: flex; justify-content:flex-end;"><span style="text-align: right"><i class=material-icons style=color:#5ac8fa>keyboard_arrow_down</i></span></div></div></div><div class=accordion-item-content><div class=row><div class=card><div class="card-content card-content-padding takis"><div class=list><ul><li class="item-content item-input"><div class=item-inner><div class="item-title item-label">Check In</div><div class=item-input-wrap>';
          r += Template7Helpers.unless.call(ctx_2, ctx_2.loginobject?.DisableReservationActions, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '<div class=item-after style="display:table; color:#3cb4eb"><span class=customspan id=ResDetailsbtnSave data-refresh=0 style=display:none>Save</span> <span class=customspan id=editbtnnewdatesin data-refresh=0>';
              r += Template7Helpers.t.call(ctx_3, 'edit', {
                hash: {},
                data: data_3 || {},
                fn: function empty() {
                  return '';
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '</span></div>';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += ' <span class="editdatesin disabled" value=" ">';
          r += c(ctx_2.ReservationInformation.CheckInDateString, ctx_2);
          r += '</span></div></div></li><li class="item-content item-input"><div class=item-inner><div class="item-title item-label">Check Out</div><div class=item-input-wrap><span class="editdatesout disabled" value=" ">';
          r += c(ctx_2.ReservationInformation.CheckOutDateString, ctx_2);
          r += '</span></div></div></li><li class="item-content item-input"><div class=item-inner><div class="item-title item-label">Room Category</div><div class=item-input-wrap><a @smartselect:close=updateHeroOpenOne() class="item-link smart-select smart-select-init smartselectroomcategory1 disabled" data-open-in=popup id=smartselectroomcategory><select name=lang>';
          r += Template7Helpers.each.call(ctx_2, ctx_2.RoomCatsList, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '<option style=color:black; value=';
              r += c(ctx_3.Key, ctx_3);
              r += '>';
              r += c(ctx_3.Val, ctx_3);
              r += '</option>';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '</select><div class=item-content><div class=item-inner><div class=item-title id=selected style=margin-left:-16px;></div></div></div></a></div></div></li><li class="item-content item-input"><div class=item-inner><div class="item-title item-label">Rate Name</div><div class=item-input-wrap><a class="item-link smart-select smart-select-init smartselectroomrate disabled" disabled=disabled data-open-in=popup><select name=lang>';
          r += Template7Helpers.each.call(ctx_2, ctx_2.RateList?.RatesList, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '<option style=color:black; value=';
              r += c(ctx_3.Key, ctx_3);
              r += ' selected=selected>';
              r += c(ctx_3.Val, ctx_3);
              r += '</option>';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '</select><div class=item-content><div class=item-inner><div class=item-title style=margin-left:-16px;></div></div></div></a></div></div></li><li class=item-content><div class=item-inner><div class=item-title>Adults: <span id=guests-count></span></div><div class=item-after><div class="quest_stepper stepper stepper-init stepper-small stepper-raised disabled" data-value-el=#guests-count><div class=stepper-button-minus></div><div class=stepper-button-plus></div></div></div></div></li><li class=item-content><div class=item-inner><div class=item-title>Children: <span id=childrens-count></span></div><div class=item-after><div class="children_stepper stepper stepper-init stepper-small stepper-raised disabled" data-value-el=#childrens-count data-max=';
          r += c(ctx_2.MaxChildren, ctx_2);
          r += '><div class=stepper-button-minus></div><div class=stepper-button-plus></div></div></div></div></li><li class="item-content item-input"><div class=item-inner><div class="item-title item-label">Room</div><div class=item-input-wrap><a class="item-link smart-select smart-select-init smartselectroom disabled" @smartselect:open=updateHeroOpenOne3() data-open-in=popup><select name=lang>';
          r += Template7Helpers.each.call(ctx_2, ctx_2.RoomsList?.RoomsList, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '<option style=color:black; value=';
              r += c(ctx_3.Key, ctx_3);
              r += ' selected=selected>';
              r += c(ctx_3.Val, ctx_3);
              r += '</option>';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '</select><div class=item-content><div class=item-inner><div class=item-title id=selectedroom style=margin-left:-16px;></div></div></div></a></div></div></li><li class="item-content item-input"><div class="item-inner disabled editbtnnewpricepernight"><div class="item-title item-label">Price Per Night</div><div class=item-input-wrap><span class=editprice id=curprice>';
          r += c(ctx_2.ReservationInformation.PricePerNight, ctx_2);
          r += ' ';
          r += c(ctx_2.ReservationInformation.Currency, ctx_2);
          r += '</span></div></div></li><li class="item-content item-input"><div class="item-inner disabled editbtnnewtotalprice"><div class="item-title item-label">Total Price</div><div class=item-input-wrap><span class=editprice class="" id=curprice2>';
          r += c(ctx_2.ReservationInformation.TotalPrice, ctx_2);
          r += ' ';
          r += c(ctx_2.ReservationInformation.Currency, ctx_2);
          r += '</span></div></div></li></ul></div></div></div></div></div></div>';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '<div class="accordion-item guest"><div class="accordion-item-toggle Dashboard"><div class=row><div class=col-70 id=guestId>Guests</div><div class=col-10></div><div class=col-20 style="display: flex; justify-content:flex-end;"><span style="text-align: right"><i class=material-icons style=color:#5ac8fa>keyboard_arrow_down</i></span></div></div></div><div class=accordion-item-content><div class=row><div class=card><div class="card-content card-content-padding takis"><div class="list no-hairlines-md"><ul><div class=block-title>Guest 1 ';
      r += Template7Helpers.unless.call(ctx_1, ctx_1.isHouseKeeper, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += ' ';
          r += Template7Helpers.unless.call(ctx_2, ctx_2.loginobject?.DisableReservationActions, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '<div class=item-after style="display:table; color:#3cb4eb"><span class=customspan hidden id=questsbtnSave data-refresh=0>Save</span> <span class=customspan id=editbtnnewforguest1 data-refresh=0>';
              r += Template7Helpers.t.call(ctx_3, 'edit', {
                hash: {},
                data: data_3 || {},
                fn: function empty() {
                  return '';
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '</span></div>';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += ' ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</div><li class="item-content item-input"><div class=item-inner><div class="item-title item-label">Name</div><div class=item-input-wrap><input type=text name=GuestInfo1name class="disabled personInfo" value=';
      r += c(ctx_1.ReservationInformation?.GuestName1, ctx_1);
      r += ' placeholder=Name></div></div></li><li class="item-content item-input"><div class=item-inner><div class="item-title item-label">SurName</div><div class=item-input-wrap><input type=text name=GuestInfo1Surname class="disabled personInfo" value=';
      r += c(ctx_1.ReservationInformation.GuestSurname1, ctx_1);
      r += ' placeholder=SurName></div></div></li><li class="item-content item-input"><div class=item-inner><div class="item-title item-label">Email</div><div class=item-input-wrap><input type=text name=GuestInfo1Email class="disabled personInfo" value=';
      r += c(ctx_1.ReservationInformation.GuestEmail1, ctx_1);
      r += ' placeholder=Email></div></div></li><li class="item-content item-input"><div class=item-inner><div class="item-title item-label">Phone</div><div class=item-input-wrap><input placeholder=Phone type=text name=GuestInfo1Phone class="disabled personInfo" value=';
      r += c(ctx_1.ReservationInformation.GuestPhone1, ctx_1);
      r += '></div></div></li><li class="item-content item-input item-input-with-info"><div class=item-inner><div class="item-title item-label">';
      r += Template7Helpers.t.call(ctx_1, 'country', {
        hash: {},
        data: data_1 || {},
        fn: function empty() {
          return '';
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</div><div class=item-input-wrap><a class="item-link smart-select smart-select-init smartselectCountryG1 disabled" data-open-in=popup data-page-back-link-text=Done data-searchbar=true data-searchbar-placeholder="Search Country"><select name=mac-windows id=countryDropdownGuest1>';
      r += Template7Helpers.each.call(ctx_1, ctx_1.Countries, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '<option style=color:black;>';
          r += c(ctx_2.Key, ctx_2);
          r += '</option>';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</select><div class=item-content><div class=item-inner><div class=item-title></div></div></div></a></div></div></li><div class=block-title>Guest 2</div><li class="item-content item-input"><div class=item-inner><div class="item-title item-label">Name</div><div class=item-input-wrap><input type=text name=GuestInfo2Name class="disabled personInfo2" placeholder=Name value=';
      r += c(ctx_1.ReservationInformation.GuestName2, ctx_1);
      r += '></div></div></li><li class="item-content item-input"><div class=item-inner><div class="item-title item-label">SurName</div><div class=item-input-wrap><input type=text name=GuestInfo2Surname class="disabled personInfo3" placeholder=Surname value=';
      r += c(ctx_1.ReservationInformation.GuestSurname2, ctx_1);
      r += '></div></div></li><li class="item-content item-input item-input-with-info"><div class=item-inner><div class="item-title item-label">';
      r += Template7Helpers.t.call(ctx_1, 'country', {
        hash: {},
        data: data_1 || {},
        fn: function empty() {
          return '';
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</div><div class=item-input-wrap><a class="item-link smart-select smart-select-init smartselectCountryG2 disabled" data-open-in=popup data-page-back-link-text=Done data-searchbar=true data-searchbar-placeholder="Search Country"><select name=mac-windows id=countryDropdownGuest2>';
      r += Template7Helpers.each.call(ctx_1, ctx_1.Countries, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '<option style=color:black;>';
          r += c(ctx_2.Key, ctx_2);
          r += '</option>';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</select><div class=item-content><div class=item-inner><div class=item-title></div></div></div></a></div></div></li></ul></div></div></div></div></div></div><div class=accordion-item><div class="accordion-item-toggle Dashboard"><div class=row><div class=col-70>Linked Profiles</div><div class=col-10></div><div class=col-20 style="display: flex; justify-content:flex-end;"><span style="text-align: right"><i class=material-icons style=color:#5ac8fa>keyboard_arrow_down</i></span></div></div></div><div class=accordion-item-content><div class=row><div class=card><div class="card-content card-content-padding takis"><div class="list no-hairlines-md"><ul><li class="item-content item-input"><div class=item-inner>';
      r += Template7Helpers.unless.call(ctx_1, ctx_1.isHouseKeeper, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += ' ';
          r += Template7Helpers.unless.call(ctx_2, ctx_2.loginobject?.DisableReservationActions, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '<div class=item-after style="display:inline-block; color:#3cb4eb"><span class=customspan style="float: left;" hidden id=linkedProfilesbtnSave data-refresh=0>Save</span> <span class=customspan style="float: right;" id=editbtnnewforlinkedProfiles data-refresh=0>';
              r += Template7Helpers.t.call(ctx_3, 'edit', {
                hash: {},
                data: data_3 || {},
                fn: function empty() {
                  return '';
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '</span></div>';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += ' ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '<div class="item-title item-label">Individual / Booker</div><div class=item-input-wrap><input type=text name=LinedProfilesGuestName class="disabled personInfo" id=idvBookName value="';
      r += c(ctx_1.ReservationInformation.GuestName1, ctx_1);
      r += ' ';
      r += c(ctx_1.ReservationInformation.GuestSurname1, ctx_1);
      r += '"> <span class=input-clear-button></span></div></div></li><li class="item-content item-input"><div class=item-inner><div class="item-title item-label">Company</div><div class="item-input-wrap linked-profiles disabled"><a class="item-link smart-select smart-select-init" data-open-in=popup id=smartselectcompany data-searchbar=true><select name=lang>';
      r += Template7Helpers.each.call(ctx_1, ctx_1.Companies, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '<option style=color:black; value=';
          r += c(ctx_2.Key, ctx_2);
          r += '>';
          r += c(ctx_2.Val, ctx_2);
          r += '</option>';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</select><div class=item-content><div class=item-inner><div class=item-title id=selected style=margin-left:-16px;></div></div></div></a></div></div></li><li class="item-content item-input"><div class=item-inner><div class="item-title item-label">Travel Agency</div><div class="item-input-wrap linked-profiles disabled"><a class="item-link smart-select smart-select-init" data-open-in=popup id=smartselectagency data-searchbar=true><select name=lang>';
      r += Template7Helpers.each.call(ctx_1, ctx_1.Agencies, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '<option style=color:black; value=';
          r += c(ctx_2.Key, ctx_2);
          r += '>';
          r += c(ctx_2.Val, ctx_2);
          r += '</option>';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</select><div class=item-content><div class=item-inner><div class=item-title id=selected style=margin-left:-16px;></div></div></div></a></div></div></li><li class="item-content item-input"><div class=item-inner><div class="item-title item-label">Group</div><div class=item-input-wrap><input type=text name=LinedProfilesGroupName class="disabled personInfo" value="';
      r += Template7Helpers.escape.call(ctx_1, ctx_1.ReservationInformation.GroupName, {
        hash: {},
        data: data_1 || {},
        fn: function empty() {
          return '';
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '"></div></div></li><li class="item-content item-input"><div class=item-inner><div class="item-title item-label">Allotment</div><div class=item-input-wrap><input type=text name=LinedProfilesAllotmentName class="disabled personInfo" value=';
      r += c(ctx_1.ReservationInformation.AllotmentName, ctx_1);
      r += '></div></div></li><li class="item-content item-input"><div class=item-inner><div class="item-title item-label">With Contact (Social Tourism)</div><div class="item-input-wrap linked-profiles disabled"><a class="item-link smart-select smart-select-init" data-open-in=popup id=smartselecttourism data-searchbar=true><select name=lang>';
      r += Template7Helpers.each.call(ctx_1, ctx_1.Tourismins, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '<option style=color:black; value=';
          r += c(ctx_2.Key, ctx_2);
          r += '>';
          r += c(ctx_2.Val, ctx_2);
          r += '</option>';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</select><div class=item-content><div class=item-inner><div class=item-title id=selected style=margin-left:-16px;></div></div></div></a></div></div></li></ul></div></div></div></div></div></div>';
      r += Template7Helpers.unless.call(ctx_1, ctx_1.isHouseKeeper, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '<div class=accordion-item><div class="accordion-item-toggle Dashboard"><div class=row><div class=col-70>Billing</div><div class=col-10></div><div class=col-20 style="display: flex; justify-content:flex-end;"><span style="text-align: right"><i class=material-icons style=color:#5ac8fa>keyboard_arrow_down</i></span></div></div></div><div class=accordion-item-content><div class=""><div class=""><div style=padding-top:0; class="card-content card-content-padding takis"><span style="text-align: right;margin-bottom: 10px">';
          r += Template7Helpers.unless.call(ctx_2, ctx_2.loginobject?.DisableReservationActions, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += ' <i @click=GetBillingTypes class=material-icons style=color:#0ffb23>add </i>';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '</span><div class="list no-hairlines-md"><input hidden id=hPaymentID value=0> <input hidden id=hNoteID value=0> <input hidden id=hTransfersID value=0><ul class=billingsrow>';
          r += Template7Helpers.unless.call(ctx_2, ctx_2.loginobject?.DisableReservationActions, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += ' ';
              r += Template7Helpers.each.call(ctx_3, ctx_3.ReservationInformation.AppPayments, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '<div class=card><span class="customspan deleteColor" @click=DeleteThisPayment(';
                  r += c(ctx_4.PaymentID, ctx_4);
                  r += ',';
                  r += c(ctx_4.Amount, ctx_4);
                  r += ') style="float: right;" data-refresh=0>Delete</span> <span class="customspan editColor" @click=EditThisPayment(';
                  r += c(ctx_4.PaymentTypeID, ctx_4);
                  r += ',';
                  r += c(ctx_4.Amount, ctx_4);
                  r += ',';
                  r += c(ctx_4.PaymentID, ctx_4);
                  r += ') style="float: right;" data-refresh=0>';
                  r += Template7Helpers.t.call(ctx_4, 'edit', {
                    hash: {},
                    data: data_4 || {},
                    fn: function empty() {
                      return '';
                    },
                    inverse: function empty() {
                      return '';
                    },
                    root: root,
                    parents: [ctx_3, ctx_2, ctx_1]
                  });
                  r += '</span><li class="item-content item-input"><div class=item-inner><div class="item-title item-label">Date</div><div class=item-input-wrap><span class="personInfo disabled" name=PaymentDate value=" ">';
                  r += c(ctx_4.CreatedDatetimeSTR, ctx_4);
                  r += '</span></div></div></li><li class="item-content item-input"><div class=item-inner><div class="item-title item-label">Payment Type</div><div class=item-input-wrap><input type=text name=PaymentName disabled=disabled class="personInfo disabled" value=';
                  r += c(ctx_4.PaymentName, ctx_4);
                  r += ' placeholder=text></div></div></li><li class="item-content item-input"><div class=item-inner><div class="item-title item-label">Amount</div><div class=item-input-wrap><span class="editprice disabled">';
                  r += c(ctx_4.Amount, ctx_4);
                  r += ' <span class=currency-symbol>';
                  r += c(ctx_4.Currency, ctx_4);
                  r += '</span></span></div></div></li></div>';
                  return r;
                },
                inverse: function (ctx_4, data_4) {
                  var r = '';
                  r += '<div class=card><li class="item-content item-input"><div class=item-inner><p>No payments found</p></div></li></div>';
                  return r;
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += ' ';
              return r;
            },
            inverse: function (ctx_3, data_3) {
              var r = '';
              r += ' ';
              r += Template7Helpers.each.call(ctx_3, ctx_3.ReservationInformation.AppPayments, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '<div class=card><li class="item-content item-input"><div class=item-inner><div class="item-title item-label">Date</div><div class=item-input-wrap><span class="personInfo disabled" name=PaymentDate value=" ">';
                  r += c(ctx_4.CreatedDatetimeSTR, ctx_4);
                  r += '</span></div></div></li><li class="item-content item-input"><div class=item-inner><div class="item-title item-label">Payment Type</div><div class=item-input-wrap><input type=text name=PaymentName disabled=disabled class="personInfo disabled" value=';
                  r += c(ctx_4.PaymentName, ctx_4);
                  r += ' placeholder=text></div></div></li><li class="item-content item-input"><div class=item-inner><div class="item-title item-label">Amount</div><div class=item-input-wrap><span class="editprice disabled">';
                  r += c(ctx_4.Amount, ctx_4);
                  r += ' <span class=currency-symbol>';
                  r += c(ctx_4.Currency, ctx_4);
                  r += '</span></span></div></div></li></div>';
                  return r;
                },
                inverse: function (ctx_4, data_4) {
                  var r = '';
                  r += '<div class=card><li class="item-content item-input"><div class=item-inner><p>No payments found</p></div></li></div>';
                  return r;
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += ' ';
              return r;
            },
            root: root,
            parents: [ctx_1]
          });
          r += '</ul></div></div></div></div></div></div>';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '<div class="accordion-item notes"><div class="accordion-item-toggle Dashboard"><div class=row><div class=col-70 id=noteId>Notes</div><div class=col-10></div><div class=col-20 style="display: flex; justify-content:flex-end;"><span style="text-align: right"><i class=material-icons style=color:#5ac8fa>keyboard_arrow_down</i></span></div></div></div><div class=accordion-item-content><div id=NotesDiv><div id=editnotesdiv class=""><div class="card-content card-content-padding takis" style="float:right;padding-top: 0;"><div class=row>';
      r += Template7Helpers.unless.call(ctx_1, ctx_1.loginobject?.DisableReservationActions, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += ' <i @click=GetNotes class=material-icons style=color:#0ffb23;float:right;>add </i>';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</div></div></div>';
      r += Template7Helpers.unless.call(ctx_1, ctx_1.loginobject?.DisableReservationActions, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += ' ';
          r += Template7Helpers.each.call(ctx_2, ctx_2.ReservationInformation.NotesModelList, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '<div class=row><div class=card><div class="card-content card-content-padding takis"><div class="list no-hairlines-md"><ul class=notes><li class="item-content item-input"><div class=item-inner><div style="display: inline-block;width:100%;"><div class="item-title item-label" style=width:60%;float:left;padding-top:10px;>';
              r += c(ctx_3.TypeIDStr, ctx_3);
              r += '</div><div class=item-after style="display:block;float: right; color:#3cb4eb;"><span class="customspan deleteColor" @click="DeleteThisNote(';
              r += c(ctx_3.NoteID, ctx_3);
              r += ',\'';
              r += c(ctx_3.Notes, ctx_3);
              r += '\')" style="float: right;" data-refresh=0>Delete</span> <span class="customspan editColor" @click="EditThisNote(';
              r += c(ctx_3.TypeID, ctx_3);
              r += ',\'';
              r += c(ctx_3.Notes, ctx_3);
              r += '\',';
              r += c(ctx_3.NoteID, ctx_3);
              r += ')" style="float: right;" data-refresh=0>';
              r += Template7Helpers.t.call(ctx_3, 'edit', {
                hash: {},
                data: data_3 || {},
                fn: function empty() {
                  return '';
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '</span></div></div><div class=item-input-wrap><textarea class="noteReservation disabled" style="height: auto;" name=';
              r += c(ctx_3.NoteID, ctx_3);
              r += '>';
              r += c(ctx_3.Notes, ctx_3);
              r += '</textarea></div></div></li></ul></div></div></div></div>';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += ' ';
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += ' ';
          r += Template7Helpers.each.call(ctx_2, ctx_2.ReservationInformation.NotesModelList, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '<div class=row><div class=card><div class="card-content card-content-padding takis"><div class="list no-hairlines-md"><ul class=notes><li class="item-content item-input"><div class=item-inner><div style="display: inline-block;width:100%;"><div class="item-title item-label" style=width:60%;float:left;padding-top:10px;>';
              r += c(ctx_3.TypeIDStr, ctx_3);
              r += '</div></div><div class=item-input-wrap><textarea class="noteReservation disabled" style="height: auto;" name=';
              r += c(ctx_3.NoteID, ctx_3);
              r += '>';
              r += c(ctx_3.Notes, ctx_3);
              r += '</textarea></div></div></li></ul></div></div></div></div>';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += ' ';
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</div></div></div><div class=accordion-item><div class="accordion-item-toggle Dashboard"><div class=row><div class=col-70>Transfer</div><div class=col-10></div><div class=col-20 style="display: flex; justify-content:flex-end;"><span style="text-align: right"><i class=material-icons style=color:#5ac8fa>keyboard_arrow_down</i></span></div></div></div><div class=accordion-item-content><div class="card-content card-content-padding takis" style="float:right;padding-top: 0;"><div class=row>';
      r += Template7Helpers.unless.call(ctx_1, ctx_1.isHouseKeeper, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += ' ';
          r += Template7Helpers.unless.call(ctx_2, ctx_2.loginobject?.DisableReservationActions, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += ' <i @click=GetTransfers class=material-icons style=color:#0ffb23;float:right;>add </i>';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += ' ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</div></div><div class=row>';
      r += Template7Helpers.unless.call(ctx_1, ctx_1.loginobject?.DisableReservationActions, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += ' ';
          r += Template7Helpers.each.call(ctx_2, ctx_2.ReservationInformation.TransfersJsonList, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '<div class=card><div class="card-content card-content-padding takis" @click="EditThisTransfers(';
              r += c(ctx_3.TransferID, ctx_3);
              r += ',';
              r += c(ctx_3.TransferType, ctx_3);
              r += ',\'';
              r += c(ctx_3.TransferDateStr, ctx_3);
              r += '\',\'';
              r += c(ctx_3.PickupLocation, ctx_3);
              r += '\',\'';
              r += c(ctx_3.DeliverLocation, ctx_3);
              r += '\',\'';
              r += c(ctx_3.Driver, ctx_3);
              r += '\',';
              r += c(ctx_3.TransferCategory, ctx_3);
              r += ',\'';
              r += c(ctx_3.DeliverLocation, ctx_3);
              r += '\',';
              r += c(ctx_3.People, ctx_3);
              r += ',';
              r += c(ctx_3.TotalPrice, ctx_3);
              r += ')"><div class=row style="position: relative;"><div class="checkedin col-50"><div style=font-weight:bold;>';
              r += c(ctx_3.TransferDateStr, ctx_3);
              r += '</div></div><div class=divider style="border-left:1px solid #c9d759; width:2px; height:20px; position:absolute; bottom:0; left:50%;"></div><div class="col-50 checkedout" style=position:relative;><div class=transferDiv style="background: ';
              r += c(ctx_3.LabelBackground, ctx_3);
              r += ';color:';
              r += c(ctx_3.LabelColor, ctx_3);
              r += ';border-color:';
              r += c(ctx_3.LabelBorder, ctx_3);
              r += ';">';
              r += c(ctx_3.TransferTypeStr, ctx_3);
              r += '</div></div></div><div><div class=row><div class=col-15>Pickup:</div><div class=col-85 style="font-weight: 500;">';
              r += c(ctx_3.PickupLocation, ctx_3);
              r += '</div></div><div class=row><div class=col-15>Deliver:</div><div class=col-85 style="font-weight: 500;">';
              r += c(ctx_3.DeliverLocation, ctx_3);
              r += '</div></div><div class=row><span class=col-100 style="display: inline-block;"><div class=col-33 style=float:left;>';
              r += c(ctx_3.TransferCategoryStr, ctx_3);
              r += '</div><div class=col-33 style=float:left;padding-left:20px;>';
              r += c(ctx_3.People, ctx_3);
              r += ' People</div><div class=col-33 style=float:left;padding-left:20px;>Total ';
              r += c(ctx_3.TotalPrice, ctx_3);
              r += ' €</div></span></div></div></div></div>';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += ' ';
          return r;
        },
        inverse: function (ctx_2, data_2) {
          var r = '';
          r += ' ';
          r += Template7Helpers.each.call(ctx_2, ctx_2.ReservationInformation.TransfersJsonList, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '<div class=card><div class="card-content card-content-padding takis"><div class=row style="position: relative;"><div class="checkedin col-50"><div style=font-weight:bold;>';
              r += c(ctx_3.TransferDateStr, ctx_3);
              r += '</div></div><div class=divider style="border-left:1px solid #c9d759; width:2px; height:20px; position:absolute; bottom:0; left:50%;"></div><div class="col-50 checkedout" style=position:relative;><div class=transferDiv style="background: ';
              r += c(ctx_3.LabelBackground, ctx_3);
              r += ';color:';
              r += c(ctx_3.LabelColor, ctx_3);
              r += ';border-color:';
              r += c(ctx_3.LabelBorder, ctx_3);
              r += ';">';
              r += c(ctx_3.TransferTypeStr, ctx_3);
              r += '</div></div></div><div><div class=row><div class=col-15>Pickup:</div><div class=col-85 style="font-weight: 500;">';
              r += c(ctx_3.PickupLocation, ctx_3);
              r += '</div></div><div class=row><div class=col-15>Deliver:</div><div class=col-85 style="font-weight: 500;">';
              r += c(ctx_3.DeliverLocation, ctx_3);
              r += '</div></div><div class=row><span class=col-100 style="display: inline-block;"><div class=col-33 style=float:left;>';
              r += c(ctx_3.TransferCategoryStr, ctx_3);
              r += '</div><div class=col-33 style=float:left;padding-left:20px;>';
              r += c(ctx_3.People, ctx_3);
              r += ' People</div><div class=col-33 style=float:left;padding-left:20px;>Total ';
              r += c(ctx_3.TotalPrice, ctx_3);
              r += ' €</div></span></div></div></div></div>';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += ' ';
          return r;
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</div></div></div><div class=accordion-item><div class="accordion-item-toggle Dashboard"><div class=row><div class=col-70>Segmentation</div><div class=col-10></div><div class=col-20 style="display: flex; justify-content:flex-end;"><span style="text-align: right"><i class=material-icons style=color:#5ac8fa>keyboard_arrow_down</i></span></div></div></div><div class=accordion-item-content><div class="row segmentationCard"><div class=card><div class="card-content card-content-padding takis"><div class="list no-hairlines-md"><ul><li class="item-content item-input"><div class=item-inner>';
      r += Template7Helpers.unless.call(ctx_1, ctx_1.isHouseKeeper, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += ' ';
          r += Template7Helpers.unless.call(ctx_2, ctx_2.loginobject?.DisableReservationActions, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '<div class=item-after style="display:flex;justify-content: right; color:#3cb4eb"><span class="customspan SegmentationSaveBtn" hidden data-refresh=0>Save</span> <span class="customspan SegmentationEditBtn" data-refresh=0>';
              r += Template7Helpers.t.call(ctx_3, 'edit', {
                hash: {},
                data: data_3 || {},
                fn: function empty() {
                  return '';
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '</span></div>';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += ' ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '<div class="item-title item-label">Origin</div><div class=item-input-wrap><a class="item-link smart-select smart-select-init disabled" data-open-in=popup id=smartselectorigin><select name=lang>';
      r += Template7Helpers.each.call(ctx_1, ctx_1.ReservationInformation.OriginList, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '<option style=color:black; value=';
          r += c(ctx_2.OriginID, ctx_2);
          r += '>';
          r += c(ctx_2.OriginName, ctx_2);
          r += '</option>';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</select><div class=item-content><div class=item-inner><div class=item-title id=OriginSelected style=margin-left:-16px;></div></div></div></a></div></div></li><li class="item-content item-input"><div class=item-inner><div class="item-title item-label">Source</div><div class=item-input-wrap><a class="item-link smart-select smart-select-init disabled" data-open-in=popup id=smartselectsource><select name=lang>';
      r += Template7Helpers.each.call(ctx_1, ctx_1.ReservationInformation.SourceList, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '<option style=color:black; value=';
          r += c(ctx_2.SourceID, ctx_2);
          r += '>';
          r += c(ctx_2.SourceName, ctx_2);
          r += '</option>';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</select><div class=item-content><div class=item-inner><div class=item-title id=OriginSelected style=margin-left:-16px;></div></div></div></a></div></div></li><li class="item-content item-input"><div class=item-inner><div class="item-title item-label">Travel Reason</div><div class=item-input-wrap><a class="item-link smart-select smart-select-init disabled" data-open-in=popup id=smartselectbusinesssegment><select name=lang>';
      r += Template7Helpers.each.call(ctx_1, ctx_1.ReservationInformation.BusinessSegmentList, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '<option style=color:black; value=';
          r += c(ctx_2.BusinessSegmentID, ctx_2);
          r += '>';
          r += c(ctx_2.BusinessSegmentName, ctx_2);
          r += '</option>';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</select><div class=item-content><div class=item-inner><div class=item-title id=OriginSelected style=margin-left:-16px;></div></div></div></a></div></div></li></ul></div></div></div></div></div></div><div class=accordion-item><div class="accordion-item-toggle Dashboard"><div class=row><div class=col-70>Policies</div><div class=col-10></div><div class=col-20 style="display: flex; justify-content:flex-end;"><span style="text-align: right"><i class=material-icons style=color:#5ac8fa>keyboard_arrow_down</i></span></div></div></div><div class=accordion-item-content><div class=row><div class=card><div class="card-content card-content-padding takis"><div class=policyCard><div class="list no-hairlines-md"><ul><li class="item-content item-input"><div class=item-inner>';
      r += Template7Helpers.unless.call(ctx_1, ctx_1.isHouseKeeper, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += ' ';
          r += Template7Helpers.unless.call(ctx_2, ctx_2.loginobject?.DisableReservationActions, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '<div class=item-after style="display:flex;justify-content: right; color:#3cb4eb"><span class="customspan PolicySaveBtn" hidden data-refresh=0>Save</span> <span class="customspan PolicyEditBtn" data-refresh=0>';
              r += Template7Helpers.t.call(ctx_3, 'edit', {
                hash: {},
                data: data_3 || {},
                fn: function empty() {
                  return '';
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '</span></div>';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += ' ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '<div class="item-title item-label">Cancellation Policy</div><div class=item-input-wrap><a class="item-link smart-select smart-select-init showsmartselect disabled" data-open-in=popup><select name=mac-windows>';
      r += Template7Helpers.each.call(ctx_1, ctx_1.ReservationInformation.CancelPolList, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '<option value=';
          r += c(ctx_2.CancellationID, ctx_2);
          r += '>';
          r += c(ctx_2.Name, ctx_2);
          r += '</option>';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</select><div class=item-content><div class=item-inner><div class=item-title></div></div></div></a></div></div></li><li class="item-content item-input"><div class=item-inner><div class="item-title item-label">Payment Policy</div><div class=item-input-wrap><a class="item-link smart-select smart-select-init showsmartselect2 disabled" data-open-in=popup><select name=mac-windows>';
      r += Template7Helpers.each.call(ctx_1, ctx_1.ReservationInformation.PayPolList, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '<option value=';
          r += c(ctx_2.PaymentPolicyID, ctx_2);
          r += '>';
          r += c(ctx_2.Name, ctx_2);
          r += '</option>';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</select><div class=item-content><div class="item-inner arrow"><div class=item-title></div></div></div></a><a></a></div></div></li></ul></div></div></div></div></div></div></div>';
      r += Template7Helpers.unless.call(ctx_1, ctx_1.isHouseKeeper, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += ' ';
          r += Template7Helpers.if.call(ctx_2, ctx_2.ReservationInformation.Messages?.length, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '<div class=accordion-item><div class="accordion-item-toggle Dashboard"><div class=row><div class=col-70>Message History</div><div class=col-10></div><div class=col-20 style="display: flex; justify-content:flex-end;"><span style="text-align: right"><i class=material-icons style=color:#5ac8fa>keyboard_arrow_down</i></span></div></div></div><div class=accordion-item-content><div class=row><div class=card><div class="card-content card-content-padding takis"><div class=policyCard><div class="list no-hairlines-md"><ul><li class="item-content item-input" style="padding-left: 0;"><div class=item-inner id=historyConversationContainer><div class="item-title item-label" id=conversation-history><ul class="media-list chat-list px-2">';
              r += Template7Helpers.each.call(ctx_3, ctx_3.ReservationInformation.Messages, {
                hash: {},
                data: data_3 || {},
                fn: function (ctx_4, data_4) {
                  var r = '';
                  r += '<li class="media reversed"><div class=media-body><div id=mh_';
                  r += c(ctx_4.ID, ctx_4);
                  r += ' class="media-content p-3 limited-content"><div class=text>';
                  r += c(ctx_4.Body, ctx_4);
                  r += '</div><div class=more><a @click=toggleMoreLess(';
                  r += c(ctx_4.ID, ctx_4);
                  r += ') id=mhml_';
                  r += c(ctx_4.ID, ctx_4);
                  r += '>... More</a></div><div class=media-date>';
                  r += c(ctx_4.DateSentStr, ctx_4);
                  r += '</div></div><span class="media-annotation display-block mt-2"></span></div></li>';
                  return r;
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '</ul></div></div></li></ul></div></div></div></div></div></div></div>';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += ' ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += ' ';
      r += Template7Helpers.unless.call(ctx_1, ctx_1.isHouseKeeper, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '<div class=accordion-item><div class="accordion-item-toggle Dashboard"><div class=row><div class=col-70>Emails</div><div class=col-10></div><div class=col-20 style="display: flex; justify-content:flex-end;"><span style="text-align: right"><i class=material-icons style=color:#5ac8fa>keyboard_arrow_down</i></span></div></div></div><div class=accordion-item-content><div class=row><div class=card><div class="card-content card-content-padding takis"><div class=policyCard><div class="list no-hairlines-md"><ul><li class="item-content item-input" style="padding-left: 0;"><div class=item-inner>';
          r += Template7Helpers.unless.call(ctx_2, ctx_2.loginobject?.DisableReservationActions, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '<div class=item-after style="display:flex;justify-content: right; color:#3cb4eb"><span class=send-btn @click=sendEmailConfrim() id=email-send-btn>Send</span></div>';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '<div class="item-title item-label">Email Template</div><div class="item-input-wrap email-input-wrap"><a class="item-link smart-select smart-select-init showsmartselectemail" @smartselect:close=selectEmail data-open-in=popup data-searchbar=true data-searchbar-placeholder="Search email template"><select id=emailSelect>';
          r += Template7Helpers.each.call(ctx_2, ctx_2.ReservationInformation.EmailTemplates, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '<option value=';
              r += c(ctx_3.ID, ctx_3);
              r += '>';
              r += c(ctx_3.Name, ctx_3);
              r += '</option>';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += '</select><div class=item-content><div class=item-inner><div class=item-title></div></div></div></a><div class=row><div style="margin-top: 10px;width: 100%;"><div class="item-title item-label">Recipient</div><input type=text id=emailTo class="email-input form-control form-control-lg" placeholder="Add a recipient" value=';
          r += c(ctx_2.ReservationInformation.GuestEmail1, ctx_2);
          r += '></div><div id=emailWrapper class=row><div class=email-label-wapper><div class="item-title item-label">Subject</div><input type=text name=subject id=emailSubject class="email-input form-control form-control-lg" placeholder="Type a subject" value=""></div><div id=emailBody contenteditable=true class="form-control form-control-lg" placeholder="Enter text here" rows=10></div></div></div></div></div></li></ul></div></div></div></div></div></div></div>';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += ' ';
      r += Template7Helpers.unless.call(ctx_1, ctx_1.isHouseKeeper, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += ' ';
          r += Template7Helpers.unless.call(ctx_2, ctx_2.loginobject?.DisableReservationActions, {
            hash: {},
            data: data_2 || {},
            fn: function (ctx_3, data_3) {
              var r = '';
              r += '<p class=row><button id=CheckInReservation class="col button button-small button-outline searchbtn color-blue" style="border-color:#d5d524; color:#dfdf6ef7!important; margin:0px 20px;">';
              r += Template7Helpers.t.call(ctx_3, 'checkin', {
                hash: {},
                data: data_3 || {},
                fn: function empty() {
                  return '';
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '</button></p><p class=row><button id=CheckOutReservation class="col button button-small button-outline searchbtn color-blue" style="border-color:#e15858; color:#e15858!important; margin:0px 20px;"><div>';
              r += Template7Helpers.t.call(ctx_3, 'checkout', {
                hash: {},
                data: data_3 || {},
                fn: function empty() {
                  return '';
                },
                inverse: function empty() {
                  return '';
                },
                root: root,
                parents: [ctx_2, ctx_1]
              });
              r += '</div></button></p><p class=row><button id=CancelReservation class="col button button-small button-outline searchbtn color-blue" style="border-color:#a80404; color:#a80404!important; margin:0px 20px;"><div>Cancel Reservation</div></button></p>';
              return r;
            },
            inverse: function empty() {
              return '';
            },
            root: root,
            parents: [ctx_1]
          });
          r += ' ';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '<div class="sheet-modal my-sheet" style="height:auto; --f7-sheet-bg-color: #fff;"><div class=toolbar><div class=toolbar-inner><div class=left></div><div class=right style="margin: 15px;"><a style="color: black;" href=# @click=SavePayment()>Save</a></div></div></div><div class=sheet-modal-inner><div class=block><h4>Add Payment</h4><div class="list no-hairlines-md"><ul><li class="item-content item-input"><div class=item-inner><div class="item-title item-label">Billing Type</div><div class=item-input-wrap><a class="item-link smart-select smart-select-init showsmartselectbillings" data-open-in=popup><select name=mac-windows>';
      r += Template7Helpers.each.call(ctx_1, ctx_1.Billings, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '<option style=color:black; value=';
          r += c(ctx_2.Key, ctx_2);
          r += '>';
          r += c(ctx_2.Val, ctx_2);
          r += '</option>';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</select><div class=item-content><div class="item-inner arrow"><div class=item-title></div></div></div></a></div></div></li><li class="item-content item-input"><div class=item-inner><div class="item-title item-label">Price</div><div class="item-input-wrap AddPaymentspan"><input type=text value="" id=AddPaymentID required></div></div></li></ul></div></div></div></div><div class="sheet-modal my-sheet-notes" style="height:auto; --f7-sheet-bg-color: #fff;"><div class=toolbar><div class=toolbar-inner><div class=left></div><div class=right style="margin: 15px;"><a style="color: black;" href=# @click=SaveNote()>Save</a></div></div></div><div class=sheet-modal-inner><div class=block><h4>Add Note</h4><div class="list no-hairlines-md"><ul><li class="item-content item-input"><div class=item-inner><div class="item-title item-label">Note Type</div><div class=item-input-wrap><a class="item-link smart-select smart-select-init showsmartselectnotes" data-open-in=popup><select name=mac-windows>';
      r += Template7Helpers.each.call(ctx_1, ctx_1.Billings, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '<option style=color:black; value=';
          r += c(ctx_2.Key, ctx_2);
          r += '>';
          r += c(ctx_2.Val, ctx_2);
          r += '</option>';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</select><div class=item-content><div class="item-inner arrow"><div class=item-title></div></div></div></a></div></div></li><li class="item-content item-input"><div class=item-inner><div class="item-title item-label">Note</div><div class="item-input-wrap AddPaymentspan"><textarea type=text value="" id=AddNoteID required></textarea></div></div></li></ul></div></div></div></div><div class="sheet-modal my-sheet-transfers" id=TransferContjs style="height:auto; --f7-sheet-bg-color: #fff;"><div class=toolbar><div class=toolbar-inner><div class=left><i @click=DeleteThisTransfers() class=material-icons id=DeleteTransfersID style="color: #f15550;float: left;margin-left: 10px;">delete</i></div><div class="right saveBtnLikeBtn"><a style="color: black;" href=# @click=SaveTransfers()>Save</a></div></div></div><div class="sheet-modal-inner transfer-sheet"><div class=block><h4>Add Transfer</h4><div class="list no-hairlines-md" style=margin:0;><ul><li class="item-content item-input"><div class=item-inner><div class="item-title item-label">Transfer Type</div><div class=item-input-wrap><a class="item-link smart-select smart-select-init showsmartselecttransfers" data-open-in=sheet data-close-on-select=true><select name=mac-windows>';
      r += Template7Helpers.each.call(ctx_1, ctx_1.TransfersType, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '<option style=color:black; value=';
          r += c(ctx_2.keyVal.Key, ctx_2);
          r += '>';
          r += c(ctx_2.keyVal.Val, ctx_2);
          r += '</option>';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</select><div class=item-content><div class="item-inner arrow"><div class=item-title></div></div></div></a></div></div></li><li class="item-content item-input"><div class=item-inner><div class="item-title item-label">Date</div><div class="item-input-wrap AddPaymentspan"><input type=text readonly=readonly required id=AddTransferDate></div></div></li><li class="item-content item-input"><div class=item-inner><div class="item-title item-label">Pickup Location</div><div class="item-input-wrap AddPaymentspan"><input type=text value="" id=AddTransferPickup required></div></div></li><li class="item-content item-input"><div class=item-inner><div class="item-title item-label">Deliver Location</div><div class="item-input-wrap AddPaymentspan"><input type=text value="" id=AddTransferDeliver required></div></div></li><li class="item-content item-input"><div class=item-inner><div class="item-title item-label">Driver</div><div class="item-input-wrap AddPaymentspan"><input type=text value="" id=AddTransferDriver required></div></div></li><li class="item-content item-input"><div class=item-inner><div class="item-title item-label">Category</div><div class=item-input-wrap><a class="item-link smart-select smart-select-init showsmartselecttransferscatefory" data-open-in=sheet data-close-on-select=true><select name=mac-windows>';
      r += Template7Helpers.each.call(ctx_1, ctx_1.TransfersCategory, {
        hash: {},
        data: data_1 || {},
        fn: function (ctx_2, data_2) {
          var r = '';
          r += '<option style=color:black; value=';
          r += c(ctx_2.keyVal.Key, ctx_2);
          r += '>';
          r += c(ctx_2.keyVal.Val, ctx_2);
          r += '</option>';
          return r;
        },
        inverse: function empty() {
          return '';
        },
        root: root,
        parents: [ctx_1]
      });
      r += '</select><div class=item-content><div class="item-inner arrow"><div class=item-title></div></div></div></a></div></div></li><li class="item-content item-input"><div class=item-inner><div class="item-title item-label">Flight Number</div><div class="item-input-wrap AddPaymentspan"><input type=text value="" id=AddTransferFlightNumber required></div></div></li><li class="item-content item-input"><div class=item-inner><div class="item-title item-label">People</div><div class="item-input-wrap AddPaymentspan"><input type=number value="" id=AddTransferPeople required></div></div><div class=item-inner><div class="item-title item-label">Total Price</div><div class="item-input-wrap AddPaymentspan"><input type=number value="" id=AddTransferPrice required></div></div></li></ul></div></div></div></div><div class="sheet-modal my-sheet-cancel" style="height:auto; --f7-sheet-bg-color: #fff;"><div class=toolbar><div class=toolbar-inner><div class=left></div><div class=right style="margin: 15px;"><a style="color: black;" href=# @click=CloseCancel()>Close</a></div></div></div><div class=sheet-modal-inner style="max-height: 690px;"><div class=block style="margin:0;max-height: 680px;overflow-y: auto;"><h4 style=margin-bottom:5px;>Cancel Reservartion</h4><div class="list no-hairlines-md" style=margin-top:5px;margin-bottom:5px;><ul><li class="item-content item-input"><div class=item-inner><div class="item-title item-label">Reservation</div><div class=item-input-wrap><div id=CancelResID></div></div></div></li><li class="item-content item-input"><div class=item-inner><div class="item-title item-label">Booking Date</div><div class=item-input-wrap><div id=CancelBookingDate></div></div></div></li><li class="item-content item-input"><div class=item-inner><div class="item-title item-label">Source</div><div class=item-input-wrap><div id=CancelSource></div></div></div></li><li class="item-content item-input"><div class=item-inner><div class="item-title item-label">Check-in/Out</div><div class=item-input-wrap><div id=CancelCheckinOut></div></div></div></li><li class="item-content item-input"><div class=item-inner><div class="item-title item-label">Customer</div><div class=item-input-wrap><div id=CancelCustomer></div></div></div></li><li class="item-content item-input"><div class=item-inner><div class="item-title item-label">Reservation Charges</div><div class=item-input-wrap><div id=CancelReservationCharges></div></div></div></li></ul></div><div class="list no-hairlines-md" style=margin-top:5px;margin-bottom:5px;><div class=item-inner style="display: inline-block;padding-left: calc(var(--f7-list-item-padding-horizontal) + var(--f7-safe-area-left));"><div class=item-input-wrap>Rate Plan</div><div class=item-input-wrap><div>This reservation was made with the rate plan</div><div id=CancelRateName style=float:left;color:#0DBBCE;></div><div>, which has the following refund policy:</div><div id=CancelCancelationPolicy></div></div></div></div><div class="list no-hairlines-md" style=margin-top:5px;margin-bottom:5px;><div class=item-inner style="display: inline-block;padding-left: calc(var(--f7-list-item-padding-horizontal) + var(--f7-safe-area-left));"><div class=item-input-wrap>Payment Details</div><div class="item-input-wrap LightOnCharge" style="font-weight: 600; color: #0DBBCE;min-height: initial;">Read carfully:</div><div class="item-input-wrap LightOnCharge"><div style=float:left;>No charge will be imposed for this booking.</div><div style=float:left;>Room charges will be removed. (</div><div id=CancelTotalCharge style=float:left;></div><div style=float:left;>)</div></div><div class=item-input-wrap><div class=list><ul><li><label class="item-checkbox item-content"><input type=checkbox id=cancelRadioCheckOne name=cancel-checkbox value=1 checked=checked> <i class="icon icon-checkbox"></i><div class=item-inner><div class=item-title>Free Cancelation</div></div></label></li><li><label class="item-checkbox item-content"><input type=checkbox id=cancelRadioCheckTwo name=cancel-checkbox value=2> <i class="icon icon-checkbox"></i><div class=item-inner><div class=item-title>Penalty Charge</div></div></label></li></ul></div></div><li class="item-content item-input"><div class=item-inner><div class="item-title item-label">Price</div><div class="item-input-wrap AddPaymentspan"><input id=CancellationFee style=opacity:0.3; @keyup=CancelFeeForValidDecimal(); type=number value=""></div></div></li></div></div><div class="list no-hairlines-md" style=margin-top:5px;margin-bottom:5px;><div class=item-inner style="display: inline-block;padding-left: calc(var(--f7-list-item-padding-horizontal) + var(--f7-safe-area-left));"><div class="item-title item-label">Notes</div><div class=item-input-wrap><input type=text value="" id=CancellationFeeText placeholder="e.g. Cancelled by phone"></div></div></div><div class="list no-hairlines-md" style=margin-top:5px;margin-bottom:5px;><div class="item-inner CancelFeeCont" style="display: inline-block;padding-left: calc(var(--f7-list-item-padding-horizontal) + var(--f7-safe-area-left));"><div class="item-title item-label CancelFeeTitle"><i class=material-icons style="font-size: 20px;float:left;">info_circle</i>Cancellation Fee</div><div class=item-input-wrap>The cancellation fee for this room will be added to the main room of this resevation</div></div></div><div class="list no-hairlines-md" style=margin-top:5px;margin-bottom:5px;><div class=item-inner style="text-align:center;display: inline-block;padding-left: calc(var(--f7-list-item-padding-horizontal) + var(--f7-safe-area-left));"><div class=item-input-wrap><button id=CancelReservationButton></button></div></div></div></div></div></div><div class="popover popover-menu"><div class=popover-inner><div class=list><ul><!-- <li data-action="isCallSupported"><a style="padding: 0 16px;"\r\n                  href="tel:';
      r += c(ctx_1.ReservationInformation.GuestPhone1, ctx_1);
      r += '" class="list-button popover-close external">Call</a>\r\n              </li> --><li data-action=isCallSupported><div class="list-button popover-close external" @click="makeCall(\'';
      r += c(ctx_1.ReservationInformation.GuestPhone1, ctx_1);
      r += '\')">Call</div></li><li data-action=isSMSSupported><div class="list-button popover-close" @click="sendSMS(\'';
      r += c(ctx_1.ReservationInformation.GuestPhone1, ctx_1);
      r += '\')">Send SMS</div></li><!-- <li data-action="isWhatsAppSupported"><a href="#" class="list-button popover-close"\r\n                  @click="openWhatsApp(';
      r += c(ctx_1.ReservationInformation.GuestPhone1, ctx_1);
      r += ')">WhatsApp</a></li> --><li><div class="list-button popover-close" @click="copyToClipboard(\'';
      r += c(ctx_1.ReservationInformation.GuestPhone1, ctx_1);
      r += '\')">Copy to Clipboard</div></li></ul></div></div></div></div></div>';
      return r;
    }(this);
  },

  style: `
  .communicator-badge {
    border-radius: 10px !important;
    position: absolute;
    top: -4px;
    right: 16px;
    font-size: 10px;
    height: 14px;
    min-width: 0px;
  }

  .chat-list,
  .chat-stacked {
    max-height: 520px;
    overflow: auto;
  }

  .media-list {
    margin-bottom: 0;
  }

  .pl-2,
  .px-2 {
    padding-left: 0.5rem !important;
  }

  .pr-2,
  .px-2 {
    padding-right: 0.5rem !important;
  }

  #conversation-history .media-list {
    background-color: #f9f9f9;
  }

  .media,
  .media-body {
    overflow: visible;
  }

  .media {
    margin-top: 20px;
    position: relative;
  }

  .media {
    display: -ms-flexbox;
    display: flex;
    -ms-flex-align: start;
    align-items: flex-start;
  }

  .chat-list .reversed .media-body {
    text-align: right;
  }

  .media-body,
  .media-left,
  .media-right {
    position: relative;
  }

  #conversation-history .media-list.chat-list .media.reversed .media-content {
    background-color: #ebf3fb;
    border-bottom-right-radius: 0;
    border-top-left-radius: 30px;
    max-width: calc(100vw - 70px);
  }

  #conversation-history .media-list.chat-list .media .media-content {
    border-radius: 30px;
  }

  .chat-list .reversed .media-content:not([class*=bg-]) {
    background-color: #42A5F5;
    border-color: #42A5F5;
  }

  .chat-list .media-content {
    position: relative;
    padding: 10px 12px;
    width: auto;
    border-radius: 3px;
    display: inline-block;
  }

  #conversation-history .media-list.chat-list .media.reversed .media-content .text {
    color: #222;
    white-space: initial;
  }

  #conversation-history .media-list.chat-list .media .media-content .text {
    font-size: 12px;
    font-weight: 400;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.25;
    letter-spacing: .36px;
  }

  #conversation-history .media-list.chat-list .media .media-date {
    color: #9a9a9a;
    font-size: 12px;
    font-weight: 400;
    font-stretch: normal;
    font-style: normal;
    line-height: .82;
    letter-spacing: .3px;
  }

  .display-block,
  label.display-block {
    display: block;
  }

  #conversation-history .media-list.chat-list .media.reversed .media-content .more {
    font-size: 12px;
    font-weight: 400;
    font-stretch: normal;
    font-style: normal;
    text-align: right;
  }

  #conversation-history .media-list.chat-list .media.reversed .media-content .media-date {
    color: #222;
    text-align: right;
  }

  #conversation-history .media-list.chat-list .media.reversed .media-content .more a {
    color: #222;
  }

  #historyConversationContainer .limited-content .text {
    max-height: 60px;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .p-3 {
    padding: 1rem !important;
  }

  .chat-list .reversed .media-content {
    text-align: left;
    color: #fff;
  }

  .media-annotation {
    color: #999;
    font-size: 12px;
    line-height: 1.6666667;
    font-weight: 400;
  }

  .mt-2,
  .my-2 {
    margin-top: 0.5rem !important;
  }

  .send-btn {
    border: 1px solid;
    border-radius: 8px;
    padding: 5px 10px;
    font-size: 16px;
  }

  .item-input-wrap.email-input-wrap::after {
    width: 0 !important;
  }

  .item-input .item-inner {
    justify-content: center;
  }

  #emailBody * {
    max-width: 29vh !important;
  }

  .showsmartselectemail,
  .email-input,
  #emailBody {
    border: 1px solid #ccc !important;
    border-radius: 5px !important;
    font-size: 13px !important;
    padding-left: 5px !important;
  }

  .email-label-wapper {
    margin: 10px 0;
    width: 100%;
  }

  #emailBody {
    width: 100%;
    min-height: 150px;
    max-height: 350px;
    resize: vertical;
    line-height: 1.5;
    display: flex;
    overflow-y: auto;
  }

  .form-control-lg {
    font-size: 1rem;
  }

  .form-control {
    -webkit-box-shadow: none;
    box-shadow: none;
  }

  .md .navbar a.link {
    color: black;
  }

  .form-control-lg {
    height: calc(1.5em + 1rem + 2px);
    padding: 0.5rem 1rem;
    font-size: 1.25rem;
    line-height: 1.5;
    border-radius: 0.3rem;
  }

  .form-control {
    display: block;
    width: 100%;
    height: calc(1.5em + 0.75rem + 2px);
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;
  }

  .external {
    padding: 13px;
  }

  .list-button.external {
    padding: 0 16px;
  }

  .saveBtnLikeBtn {
    border-radius: 5px;
    border: 1px solid black;
    margin-right: 7px;
    padding: 7px 15px;
  }

  .dangerButtonCons {
    background-color: #f77975;
    border-color: #f77975;
    color: #fff;
    padding: 3px 7px;
    margin-right: 5px;
    font-size: 18px;
    margin-bottom: 0;
    border: 1px solid #f0f0f0;
    text-align: center;
    vertical-align: middle;
    line-height: 21px;
    border-radius: 13px;
    max-width: 190px;
  }

  .primaryButtonCons {
    color: #fff;
    background-color: #0DBBCE !important;
    border-color: #0DBBCE !important;
    padding: 3px 7px;
    margin-right: 5px;
    font-size: 18px;
    margin-bottom: 0;
    border: 1px solid #f0f0f0;
    text-align: center;
    vertical-align: middle;
    line-height: 21px;
    border-radius: 13px;
    max-width: 190px;
  }

  .CancelFeeCont {
    background: #E8EEFE;
    border-left: 2px solid #435EF3;
    padding: 15px;
    padding-bottom: 10px;
  }

  .CancelFeeTitle {
    color: #435EF3 !important;
    padding-bottom: 5px;
    font-size: 18px !important;
  }

  .transferDiv {
    font-weight: 500;
    position: absolute;
    top: -5px;
    right: 35%;
    width: auto;
    float: left;
    padding: 5px;
    border-radius: 4px;
    text-transform: uppercase;
    border: 1px solid;
    font-size: 12px;
  }

  .noShowClass {
    display: none;
  }

  #editnotesdiv {
    background-color: white !important;
    width: 100%;
  }

  .AddPaymentspan:after {
    content: '€';
  }

  .smart-select .item-after {
    margin-left: -14px;
    padding-left: 0;
    color: black;
    font-size: 16px;
  }

  .policyCard .item-after {
    white-space: normal;
    max-width: 100% !important;
  }

  .customspan {
    padding: 10px;
    font-size: 16px;
  }

  .arrowclass .list .item-link .item-inner:before,
  .links-list a:before,
  .media-list .item-link .item-title-row:before,
  li.media-item .item-link .item-title-row:before,
  .media-list.chevron-center .item-link .item-inner:before,
  .media-list .chevron-center .item-link .item-inner:before,
  .media-list .item-link.chevron-center .item-inner:before,
  li.media-item.chevron-center .item-link .item-inner:before,
  li.media-item .chevron-center .item-link .item-inner:before,
  li.media-item .item-link.chevron-center .item-inner:before {
    color: #b0d7e9;
  }

  .deleteColor {
    color: rgb(231, 13, 13);
  }

  .editColor {
    color: #3cb4eb;
  }
`,
  styleScoped: false
};
    